import React, { useState, useEffect, useContext, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../../Header/auth - context";
import { useSelector } from "react-redux";
import usePermission from "../../../custom/usePermission";
import { useTranslation } from "react-i18next";
import { RSD, spremiStavke, upisiStavke, ukupnoZaFakturu } from './stavkeOtpremnice';
import { useDispatch } from "react-redux";
import { Column } from "primereact/column";
import { Tooltip } from 'primereact/tooltip';
import { FileUpload } from 'primereact/fileupload';
import CustomDropdown from "../../../custom/customDropdown";
import { exportInvoiceToExcel } from "./faktureStrane/exportInvoiceToExcel";
import "primeicons/primeicons.css";
import { Accordion, AccordionTab } from 'primereact/accordion';
import ConfirmationModalFaktura from "../../../custom/ConfirmationModalFaktura";
import { useLocation } from "react-router-dom";
import handlePrintInvoice from './faktureStrane/fakturaStampa';
import { exportInvoiceWithFiles } from './faktureStrane/exportInvoiceWithFiles';
import { uzmiGresku } from '../../../custom/greske';


const NovaDinarska = (props) => {

  const auth = useContext(AuthContext);
  const toast = useRef(null);
  /* Vozilo koje stavka koja se menja VEĆ ima u bazi. Neaktivno (prodato) vozilo
     se sme ponovo izabrati na toj stavci — npr. posle promene šifre stavke, koja
     briše izbor vozila — ali ne i na potpuno novoj stavci. */
  const voziloStavkeIzBaze = useRef(null);
  const formRef = useRef(null);
  const formRefItems = useRef(null);
  const pdfRef = useRef(null);
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const invoice = useSelector((state) => state.invoice);
  const eskaliran = useSelector((state) => state.eskaliran);
  const userRole = useSelector((state) => state.user_role);
  const { can } = usePermission();
  const { t } = useTranslation();
  const [tipFakture, setTipFakture] = useState(null);
  
  const classDocumentDB = 'btnHasDocument';
  const [activeIndex, setActiveIndex] = useState(0)
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmittedItems, setFormSubmittedItems] = useState(false);
  const [grupaFakture, setGrupaFakture] = useState(false);

  const [podTipFakture, setPodTipFakture] = useState(null);
  const [idDrzava, setIdDrzava] = useState(null);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [sefKonfigurisan, setSefKonfigurisan] = useState(false);
  /* Razlog iz /sef/CheckConfig — bez njega toast ne ume da kaže ni šta fali
     ni gde se to podešava, pa korisnik ostane bez sledećeg koraka. */
  const [sefRazlog, setSefRazlog] = useState('');
  const [sefLoading, setSefLoading] = useState(false);
  const [sefDialog, setSefDialog] = useState({ visible: false, type: null, komentar: '' });
  const [buttonDocumentDB, setButtonDocumentDB] = useState({
          uploadedFileInvoice: 0,
          brojPriloga: 0
          })
  const [prilogModalVisible, setPrilogModalVisible] = useState(false);
  const [prilogUploading, setPrilogUploading] = useState(false);
  const [prilozi, setPrilozi] = useState([]);
  const [vrstaDokumentaOptions, setVrstaDokumentaOptions] = useState([]);

  const [klijentiOptions, setKlijentiOptions] = useState([]);
  const [vrstaFaktureOptions, setVrstaFaktureOptions] = useState([]);
  const [magacinOptions, setMagacinOptions] = useState([]);
  const [vozilaOptions, setVozilaOptions] = useState([]);
  const [artikalOptions, setArtikalOptions] = useState([]);
  const [jedinicaMereOptions, setJedinicaMereOptions] = useState([]);
  
  const [kurseviOptions, setKurseviOptions] = useState([]);
  const [drzaveOptions, setDrzaveOptions] = useState([]);
  const [tekuciRacunOptions, setTekuciRacunOptions] = useState([]);
  // const [tekuciRacunOptionsFiltered, setTekuciRacunOptionsFiltered] = useState([]);
  const [valutaOptions, setValutaOptions] = useState([]);
  const [referentiOptions, setReferentiOptions] = useState([]);
  const [grupaFaktureOptions, setGrupaFaktureOptions] = useState([]);

  /* Spisak grupa nudi SVE grupe — i transport, magacin i servis, iako one
     stavke dobijaju iz svojih modula (Ture, Magacin, Servis). Faktura se pri
     izmeni mora prepoznati po svojoj grupi; ranije je „Faktura magacin" (298)
     bila izbačena iz spiska. Šta sme da se radi sa stavkama odlučuje dugme „+"
     (samo prodaja vozila), ne spisak grupa. */
  const grupaFaktureOptionsPonudjene = grupaFaktureOptions || [];
  const [idTrip, setIdTrip] = useState(null);
  const [idInvoice, setIdInvoice] = useState(null);
  const [idItem, setIdItem] = useState(null);
  const [idService, setIdService] = useState(null);
  const [idArtikal, setIdArtical] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  
  const [finansijskiStatusOptions, setFinansijskiStatusOptions] = useState([]);
  const [statusSefaOptions, setStatusSefaOptions] = useState([]);

  //Stavke
  const [sifraStavkeOptions, setSifraStavkeOptions] = useState([]);
  const [izabran, setIzabran] = useState(false);
  const [popuni, setPopuni] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(1);
  const isStornirana = invoiceStatus === 0;

  // — Konačna faktura kreirana iz predračuna —
  const [avansniZaPrikaz, setAvansniZaPrikaz] = useState([]);
  const [predracunStavkeZaIzbor, setPredracunStavkeZaIzbor] = useState([]);
  const [selectedPredracunStavke, setSelectedPredracunStavke] = useState([]);
  const [brojPredracunaPrikaz, setBrojPredracunaPrikaz] = useState('');
  const [idPredracunVezan, setIdPredracunVezan] = useState(null);

  const [allColumns, setAllColumns] = useState([]);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; 
  
  const Add2HoursDate = (input) => {
    const base = new Date(input);
    const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

    return plus2h
  }

  const returnCourseForDate = (valutaOp,nalogValuta, kurseviOp,date) => {

          const base = new Date(date);
          const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

          const toLocalYMD = (d) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

          const valutaId = Number(nalogValuta);

          let d = new Date(plus2h);
          let kurs = null;

          for (let i = 0; i < 365; i++) {
            const day = toLocalYMD(d);

            // IMPORTANT: DateEntered je string -> uporedi slice(0,10), ne new Date(...).toISOString()
            kurs = kurseviOp.find(x =>
              Number(x.id) === valutaId &&
              typeof x.DateEntered === "string" &&
              x.DateEntered.slice(0, 10) === day
            );

            if (kurs) break;

            // idi 1 dan unazad
            d.setDate(d.getDate() - 1);
          }
          return kurs ? kurs.srednji : null

  }

  const returnCourseForToday = (valutaOp,nalogValuta, kurseviOp) => {
       const base = new Date();
          const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

          // helper: lokalni YYYY-MM-DD (bez UTC zezanja)
          const toLocalYMD = (d) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

          const valutaFinal = valutaOp.find(x => x.value == nalogValuta);
          if (!valutaFinal) {
            console.log("Nema valute za:", nalogValuta);
            return;
          }

          const valutaId = Number(valutaFinal.value); // da se poklope tipovi sa x.id

          // traži unazad do 365 dana (promeni po želji)
          let d = new Date(plus2h);
          let kurs = null;

          for (let i = 0; i < 365; i++) {
            const day = toLocalYMD(d);

            // IMPORTANT: DateEntered je string -> uporedi slice(0,10), ne new Date(...).toISOString()
            kurs = kurseviOp.find(x =>
              Number(x.id) === valutaId &&
              typeof x.DateEntered === "string" &&
              x.DateEntered.slice(0, 10) === day
            );

            if (kurs) break;

            // idi 1 dan unazad
            d.setDate(d.getDate() - 1);
          }
          return kurs.srednji

  }

  useEffect(() => {
    const {
      podTipFakture,
      idDrzava,
      klijentiOptions,
      vrstaFaktureOptions,
      magacinOptions,
      vozilaOptions,
      kurseviOptions,
      drzaveOptions,
      tekuciRacunOptions,
      valutaOptions,
      tipFakture,
      grupaFaktureOptions,
      sifraStavkeOptions,
      jedinicaMereOptions,
      referentiOptions,
      tripSelected,
      valutaOpcija,
      finansijskiStatusOptions,
      statusSefaOptions
    } = props;
    
    setIdInvoice(props.idInvoice)

    setPodTipFakture(podTipFakture);
    setIdDrzava(idDrzava);
    setKlijentiOptions(klijentiOptions);
    setVrstaFaktureOptions(vrstaFaktureOptions);
    setMagacinOptions(magacinOptions);
    setArtikalOptions(props.artikalOptions || []);
    setVozilaOptions(vozilaOptions);

    let noviRacuni; 
    if(tekuciRacunOptions?.length > 0)
    noviRacuni = tekuciRacunOptions.filter(x=> x?.tipRacuna == 1)

    setTekuciRacunOptions(noviRacuni);
    setDrzaveOptions(drzaveOptions);
    setKurseviOptions(kurseviOptions);
    setValutaOptions(valutaOptions);
    setTipFakture(tipFakture);
    setReferentiOptions(referentiOptions);
    setSifraStavkeOptions(sifraStavkeOptions);
    setJedinicaMereOptions(jedinicaMereOptions);
    setGrupaFaktureOptions(grupaFaktureOptions);
    setFinansijskiStatusOptions(finansijskiStatusOptions);
    setStatusSefaOptions(statusSefaOptions);

    /* Faktura iz otpremnice (Magacin → „Unesi fakturu"). Grupa je „Faktura
       magacin" (298), kao što radni nalog nosi „Faktura transport" (297).
       Cene se NE pogađaju — otpremnica ih nema; operater ih upisuje. */
    const otpr = props.otpremnicaSelected && props.otpremnicaSelected[0];
    if (otpr) {
      /* Stavka koja je vec na nekoj fakturi se ne prenosi drugi put. */
      const zaPrenos = (otpr.Stavke || []).filter(x => Number(x.vecFakturisana) !== 1);
      if ((otpr.Stavke || []).length > 0 && zaPrenos.length === 0) {
        toast.current?.show({
          severity: 'info', summary: t('magacin.fakturaSveFakturisane'), life: 5000,
        });
      }
      /* Iznos zaglavlja = zbir stavki koje se prenose, u RSD (dinarska faktura
         je uvek u dinarima, pa se cene u drugoj valuti preracunavaju). */
      const ukupno = ukupnoZaFakturu({
        stavke: zaPrenos, ciljValuta: RSD, kursevi: props.kurseviOptions,
      });

      setGrupaFakture(298);
      setSifraProdajeRobe(otpr.sifraStavkeProdaja ?? null);
      setStavkeOtpremnice(zaPrenos);
      setFormData(prev => ({
        ...prev,
        fakturaBr: "",
        id_klijent: otpr.klijent,
        /* „Standardna faktura" — jedina vrsta koja se u praksi koristi za robu. */
        vrstaFakture: 300,
        /* Jedan račun te vrste = nema šta da se bira. Više njih ostavlja izbor. */
        tekuciRacun: noviRacuni.length === 1 ? noviRacuni[0].value : prev.tekuciRacun,
        iznos: ukupno,
        iznosValuta: RSD,
        valuta: RSD,
        /* Dinarska faktura: kurs je 1, isto kako stoji na postojećim dinarskim
           fakturama u bazi. */
        kurs: 1,
        vozilo: otpr.Registracija || "",
        refNasa: otpr.broj,
        napomena: otpr.napomena || "",
        datum: new Date(),
        dpu: otpr.datumIsporuke ? new Date(otpr.datumIsporuke) : (otpr.datum ? new Date(otpr.datum) : new Date()),
        rokPlacanjaDani: otpr.rokPlacanjaDani,
        rokPlacanjaDatum: otpr.rokPlacanjaDani ? addDays(new Date(), otpr.rokPlacanjaDani) : null,
      }));
    }

    if (tripSelected.length > 0) {

      // let klientAcc = tekuciRacunOptions.filter(x=> x.id_klijent === tripSelected[0].klijent)
      // setTekuciRacunOptionsFiltered(klientAcc)
      setIdTrip(tripSelected[0].radniNalog)
      setGrupaFakture(297);
      setFormData({
        // header
        fakturaBr: "", // readonly
        id_klijent: tripSelected[0].klijent, // *
        vrstaFakture: null, // *
        vozilo: tripSelected[0].vozilo,
        cmr: "",
        refNasa: tripSelected[0].referentniBrojRN,
        refNo: tripSelected[0].referentniBroj || "",

        iznos: tripSelected[0].Iznos,
        iznosValuta: tripSelected[0].valuta, // "RSD" | "EUR"
        napomenaPoreskoOslobadjanje: "",
        napomena: "",

        datum: new Date(),
        mestoIzdavanja: tripSelected[0].MestoIzdavanja, // readonly
        dpu: Add2HoursDate(tripSelected[0].Istovari[tripSelected[0].Istovari.length - 1].datumIstovara), // datum
        rokPlacanjaDani: tripSelected[0].rokPlacanjaDani,
        rokPlacanjaDatum: addDays(new Date(), tripSelected[0].rokPlacanjaDani), // dpu + rokPlacanjaDani

        tekuciRacun: null,

        zemljaUtovara: tripSelected[0].Utovari[tripSelected[0].Utovari.length - 1].zemljaUtovara,
        zemljaIstovara: tripSelected[0].Istovari[tripSelected[0].Istovari.length - 1].zemljaIstovara,
        posiljalac: tripSelected[0].Utovari[tripSelected[0].Utovari.length - 1].nazivPreduzecaUtovara,
        primalac: tripSelected[0].Istovari[tripSelected[0].Istovari.length - 1].nazivPreduzecaIstovara,

        brojTure: tripSelected[0].referentniBrojRN, // readonly
        jci: "",
        mestoIzvrsenjaUsluge: tripSelected[0].Istovari[tripSelected[0].Istovari.length - 1].gradIstovara,
        relacija: tripSelected[0].relacija, // readonly
        roba: tripSelected[0].Utovari[tripSelected[0].Utovari.length - 1].vrstaRobeUtovara,

        datumUtovara: Add2HoursDate(tripSelected[0].Utovari[tripSelected[0].Utovari.length - 1].datumUtovara),
        datumIstovara: Add2HoursDate(tripSelected[0].Istovari[tripSelected[0].Istovari.length - 1].datumIstovara),

        valuta: valutaOpcija, // *
        kurs:  tripSelected[0].obracunKursa == 181 ? returnCourseForToday(valutaOptions,tripSelected[0].valuta,kurseviOptions) : tripSelected[0].kurs, // *

        finansijskiStatus: tripSelected[0].finansijskiStatus, // *
        statusSefa: tripSelected[0].statusSefa, // *
        datumSlanjaPoste: null,
        datumPrijemaPoste: null,
        DateEntered: null
      });
    }  

    setFormData(prev => ({ ...prev, valuta: props.valutaOpcija}));

    if (props.idInvoice) {
          popuniRedove(props.idInvoice)
      } else if (props.idPredracunZaKonacni) {
          loadPredracunZaKonacnu(props.idPredracunZaKonacni);
      }
  }, [props]);

  useEffect(() => {
    return () => {
      setIdInvoice(null);
      setIzabran(false)
      resetData();
      resetDataFiles();
      resetDataItems();
    };
  }, []);

  useEffect(() => {
            if(!idInvoice){
            setIzabran(false);
            resetDataFiles();
            resetDataItems();
            }
        }, [props.changeView]);

  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/sef/CheckConfig', {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + auth.token }
    })
      .then(r => r.json())
      .then(data => {
        setSefKonfigurisan(data.configured === true);
        setSefRazlog(data.reason || '');
      })
      .catch(() => { setSefKonfigurisan(false); setSefRazlog(''); });
  }, []);

  // ─── Navigacija strelicama (prethodna/sledeća faktura) ───────────────────────
  const [navList, setNavList] = useState([]);

  const fetchNavList = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetALLInvoicesData', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ tip: 303, pregled: 'FAKTURA' })
    })
      .then(r => r.json())
      .then(data => {
        const list = (data || [])
          .map(r => ({ id: r.Izaberi, isDinarska: r['Podtip fakture'] === 'Dinarska faktura' }))
          .sort((a, b) => Number(a.id) - Number(b.id));
        setNavList(list);
      })
      .catch(() => setNavList([]));
  };

  useEffect(() => {
    fetchNavList();
  }, [auth.token, company.companyId]);

  // ====== DATA =====

  const [formData, setFormData] = useState({
    // header
    fakturaBr: "", // readonly
    id_klijent: null, // *
    vrstaFakture: null, // *
    vozilo: "",
    cmr: "",
    refNasa: "",
    refNo: "",

    iznos: null,
    iznosValuta: "", // "RSD" | "EUR"
    napomenaPoreskoOslobadjanje: "",
    napomena: "",

    datum: null,
    mestoIzdavanja: "", // readonly
    dpu: null, // datum
    rokPlacanjaDani: null,
    rokPlacanjaDatum: null, // dpu + rokPlacanjaDani

    tekuciRacun: null,

    zemljaUtovara: null,
    zemljaIstovara: null,
    posiljalac: "",
    primalac: "",

    brojTure: "", // readonly
    jci: "",
    mestoIzvrsenjaUsluge: "",
    relacija: "", // readonly
    roba: "",

    datumUtovara: null,
    datumIstovara: null,

    valuta: null, // *
    kurs: null, // *
    finansijskiStatus: null, // *
    statusSefa: null, // *
    sefStatusString: null, // SEF string status: Draft/New/SendingError/Sent/Approved/Rejected/Cancelled/Storno
    sefKomentar: null,

    datumSlanjaPoste: null,
    datumPrijemaPoste: null,

    DateEntered: null
  });

  // 219 = poslata na SEF (iz dbo.model_gen_konfiguracija)
  const SEF_POSLATA = 219;
  const isSefPoslata = formData.statusSefa === SEF_POSLATA && !['Storno', 'Cancelled'].includes(formData.sefStatusString);
  const isSefStornirana = ['Storno', 'Cancelled'].includes(formData.sefStatusString);
  const isNaplacena = finansijskiStatusOptions.find(o => String(o.value) === String(formData.finansijskiStatus))?.label === 'Naplaćena';
  const isLocked = isStornirana || isSefPoslata || isSefStornirana || isNaplacena;
  // Samo stornirana faktura je potpuno zaključana — Naplaćena/poslata na SEF i dalje
  // dozvoljava promenu finansijskog statusa i slanje na SEF.
  const isHardLocked = isStornirana || isSefStornirana;
  const isStandardnaFaktura = vrstaFaktureOptions.find(o => o.value === formData.vrstaFakture)?.label === 'Standardna faktura';
  const lockReason = isStornirana
    ? 'Faktura je stornirana — forma je zaključana, samo za pregled.'
    : isSefStornirana
      ? 'Faktura je stornirana/otkazana na SEF-u — forma je zaključana, samo za pregled.'
      : isSefPoslata
        ? 'Faktura je poslata na SEF — izmene nisu dozvoljene.'
        : isNaplacena
          ? 'Faktura je naplaćena — izmene nisu dozvoljene.'
          : '';
  const lockStyle = isStornirana || isSefStornirana
    ? { background: '#fdecea', border: '1px solid #f5c2c0', color: '#a02622' }
    : isSefPoslata
      ? { background: '#fff8e1', border: '1px solid #ffe69c', color: '#856404' }
      : { background: '#eafaf0', border: '1px solid #b7e4c7', color: '#1e7e34' };

  /* Stavke otpremnice čekaju ovde dok se zaglavlje fakture ne sačuva —
     stavka bez id-a fakture nema gde da se upiše. */
  const [stavkeOtpremnice, setStavkeOtpremnice] = useState([]);
  const [sifraProdajeRobe, setSifraProdajeRobe] = useState(null);

  const [formDataItems, setFormDataItems] = useState({
    sifraStavke: null, 
    tekst: "", 
    slobodanTekst: "", 
    jedinicnaCena: null,
    kolicina: null,
    neto: null,
    bruto: null,
    PDVstopa: null,
    PDVIznos: null,
    //VOZILO
    id_vozilo: null,
     // MAGACIN
    id_magacin: null, // *
    artikal: null,
    jedinicaMere: null,
    rabatProc:null,
    rabat:null
  });


  const popuniStavkeItems = (apiData) => {
    /* Prazan red = stavka nije nađena (obrisana u međuvremenu, druga firma).
       Bolje poruka nego forma popunjena do pola. */
    if (!apiData?.StavkeDB?.[0]) {
      toast.current?.show({
        severity: 'warn', summary: t('fakture.podaciNisuStigli'), life: 5000,
      });
      return;
    }

        setFormDataItems({
      sifraStavke: apiData.StavkeDB?.[0].sifraStavke || null, 
      tekst: apiData.StavkeDB?.[0].tekst || "", 
      slobodanTekst: apiData.StavkeDB?.[0].slobodanTekst || "", 
      jedinicnaCena: apiData.StavkeDB?.[0].jedinicnaCena || null, 
      kolicina: apiData.StavkeDB?.[0].kolicina || null, 
      neto: apiData.StavkeDB?.[0].neto, 
      bruto: apiData.StavkeDB?.[0].bruto, 
      PDVstopa: apiData.StavkeDB?.[0].PDVstopa, 
      PDVIznos: apiData.StavkeDB?.[0].PDVIznos,
      id_vozilo: apiData.StavkeDB?.[0].id_vozilo || null,
      id_magacin: apiData.StavkeDB?.[0].id_magacin || null,
      artikal: apiData.StavkeDB?.[0].artikal || null,
      jedinicaMere: apiData.StavkeDB?.[0].jedinicaMere || null,
      rabatProc: apiData.StavkeDB?.[0].rabatProc,
      rabat: apiData.StavkeDB?.[0].rabat
    });

    /* Vozilo stavke nije u spisku vozila — spisak nosi samo AKTIVNA vozila firme,
       a prodato vozilo posle prenosa/odjave ima Status 0. Bez ovoga je polje
       „Vozilo" ostajalo prazno iako je vozilo upisano na stavci. */
    const s0 = apiData.StavkeDB[0];
    voziloStavkeIzBaze.current = s0.id_vozilo || null;
    if (s0.id_vozilo && !(vozilaOptions || []).some(o => String(o.value) === String(s0.id_vozilo))) {
      setVozilaOptions(prev => [...(prev || []), {
        value: s0.id_vozilo,
        label: `${s0.voziloRegistracija || s0.id_vozilo}`,
        aktivno: s0.voziloAktivno === 1 ? 1 : 0,
        KarakteristikeTekst: s0.tekst || '',
      }]);
    }
  }

  const [formDataFILES, setFormDataFILES] = useState({
          uploadedFileInvoice: []
      });

      
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }
  
  const fileOptions = formDataFILES.uploadedFileInvoice
    .filter(f => f && f.name) // skini null/undefined (rešava "prazan red")
    .map(f => ({
      label: f.name,
      value: `${f.name}_${f.size}_${f.lastModified}`, // unique-ish
      file: f
    }));

  const resetDataFiles = () => {
    setFormDataFILES({
          uploadedFileInvoice: []
      });
  }
  
  const MAX_PRILOGA_SEF = 3;

  const getDocumentLocation = (path) => {
    if (!path) return null;
    const normalizedPath = path.replace(/\\/g, '/');
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodeURI(relativePath)}`;
  };

  const fetchPrilozi = (id_faktura) => {
    if (!id_faktura) return;
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetFakturaPrilozi', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id_faktura })
    })
      .then(r => r.json())
      .then(data => {
        setPrilozi(data?.PodaciDB || []);
        setVrstaDokumentaOptions(data?.SifarnikDB || []);
        setButtonDocumentDB(prev => ({ ...prev, brojPriloga: (data?.PodaciDB || []).length }));
      })
      .catch(() => {});
  };

  const handlePrilogVrstaChange = (row, id_vrsta_dokumenta) => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/UpdateFakturaPrilogVrsta', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: row.id, id_vrsta_dokumenta, Opis: row.Opis })
    })
      .then(handleErrors)
      .then(() => {
        const naziv = vrstaDokumentaOptions.find(o => o.id === id_vrsta_dokumenta)?.opis || null;
        setPrilozi(prev => prev.map(p => p.id === row.id ? { ...p, id_vrsta_dokumenta, VrstaDokumenta: naziv } : p));
      })
      .catch(() => {
        toast.current?.show({ severity: 'error', summary: 'Greška pri izmeni vrste dokumenta.', life: 3000 });
      });
  };

  const handlePrilogOpisChange = (row, opis) => {
    setPrilozi(prev => prev.map(p => p.id === row.id ? { ...p, Opis: opis } : p));
  };

  const handlePrilogOpisBlur = (row) => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/UpdateFakturaPrilogVrsta', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: row.id, id_vrsta_dokumenta: row.id_vrsta_dokumenta, Opis: row.Opis })
    }).catch(() => {
      toast.current?.show({ severity: 'error', summary: 'Greška pri izmeni opisa.', life: 3000 });
    });
  };

  const handlePrilogSefChange = (row, checked) => {
    if (checked) {
      const brojOznacenih = prilozi.filter(p => p.id !== row.id && p.SlanjeNaSef).length;
      if (brojOznacenih >= MAX_PRILOGA_SEF) {
        toast.current?.show({ severity: 'warn', summary: `Maksimalno ${MAX_PRILOGA_SEF} priloga može biti označeno za slanje na SEF.`, life: 4000 });
        return;
      }
    }
    setPrilozi(prev => prev.map(p => p.id === row.id ? { ...p, SlanjeNaSef: checked } : p));
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/UpdateFakturaPrilogSef', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: row.id, SlanjeNaSef: checked })
    }).catch(() => {
      toast.current?.show({ severity: 'error', summary: 'Greška pri izmeni statusa slanja na SEF.', life: 3000 });
    });
  };

  const handleDeletePrilog = (row) => {
    confirmDialog({
      message: 'Da li ste sigurni da želite da obrišete ovaj prilog?',
      acceptLabel: 'Da',
      rejectLabel: 'Ne',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/DeleteFakturaPrilog', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({ id: row.id })
        })
          .then(handleErrors)
          .then(() => {
            setPrilozi(prev => prev.filter(p => p.id !== row.id));
            setButtonDocumentDB(prev => ({ ...prev, brojPriloga: Math.max(0, (prev.brojPriloga || 0) - 1) }));
          })
          .catch(() => {
            toast.current?.show({ severity: 'error', summary: 'Greška pri brisanju priloga.', life: 3000 });
          });
      }
    });
  };

  const handleChangeDocUpload = (name, files) => {


        if (name === 'uploadedFileInvoice') {
            if (files) {
                const filesArray = Array.isArray(files) ? files : [files];
                setFormDataFILES(prev => ({
                    ...prev,
                    [name]: [...prev[name], ...filesArray]
                }));
            } else {
                setFormDataFILES(prev => ({ ...prev, [name]: [] }));
            }
        }
    };

  const handleUploadAndSaveFiles = async (id)=> {
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "fakture");

                                            Object.entries(formDataFILES).forEach(([key, value]) => {
                                                if (value) {
                                                    if (Array.isArray(value)) {
                                                        // Ako je vrednost niz fajlova (npr. uploadedFileGeneral)
                                                        value.forEach(file => {
                                                            formData.append(key, file); // NE koristi [index]!
                                                        });
                                                    } else {
                                                        // Ako je jedan fajl (npr. uploadedFileAPR)
                                                        formData.append(key, value);
                                                    }
                                                }
                                            });

                                       

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/InsertInvoiceFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
                                                    
                                                    setIzabran(false)

                                                    resetDataFiles()

                                                    fetchPrilozi(id)

                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                uzmiGresku(error).then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage[0].message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })

    }

  const uploadPriloziNow = (id, files) => {
    if (!id || !files || files.length === 0) return;

    const formData = new FormData();
    formData.append("id", id);
    formData.append("entityType", "fakture");
    files.forEach(file => formData.append("uploadedFileInvoice", file));

    setPrilogUploading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/InsertInvoiceFiles", {
      method: "POST",
      headers: { Authorization: "Bearer " + auth.token },
      body: formData
    })
      .then(handleErrors)
      .then((data) => {
        fetchPrilozi(id);
        toast.current.show({ severity: "success", summary: data.message, life: 3000 });
      })
      .catch((error) => {
        uzmiGresku(error).then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage?.[0]?.message || errorMessage?.message, life: 3000 });
        });
      })
      .finally(() => setPrilogUploading(false));
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const handleStampaj = async () => {
     if(idInvoice) {
              let requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token,
              },
              body: JSON.stringify({
                id: idInvoice,
                QR: true
              }),
            };
            
            await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/PrintInvoice", requestOptions)
              .then(handleErrors)
              .then((data) => {

                if(data && data.htmlContent){
                  handlePrintInvoice(data)
                }
        
              })
              .catch((error) => {
                uzmiGresku(error).then((errorMessage) => {
                  toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: errorMessage.message,
                    life: 3000,
                  });
                  console.log(errorMessage);
                });
              });
            } else {
               toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Niste izabrali fakturu kako bi je štampali!",
                    life: 3000,
                  });
            }
  } 
  const handleStorno = () => {
    if (can('FAKTURE', 'delete')) {
            confirmDialog({
                  message: `Jel ste sigurni da želite pasivizirati izabranu fakturu?`,
                  acceptLabel: "Da",
                  rejectLabel: "Ne",
                  icon: "pi pi-info-circle",
                  acceptClassName: "p-button-danger",
                  accept: acceptDeleteInvoice,
                  reject: rejectDeleteInvoice,
                });
  
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Nemate odgovarajuću ulogu profila za storaniranje fakture!",
        life: 3000,
      });
    }
  };

 const acceptDeleteInvoice = async () => {

    if (idInvoice) {
      let requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: idInvoice
        }),
      };

      await fetch(
        process.env.REACT_APP_BACKEND_URL + "/invoice/DeleteInvoice",
        requestOptions
      )
        .then(handleErrors)
        .then((data) => {

              if(data[0].message){
                  toast.current.show({
                  severity: "warn",
                  summary: data[0].message,
                  life: 3000,
                  });
                return
              }

          const wasKonacna = !!(idPredracunVezan || (props.idPredracunZaKonacni));
          setIdInvoice(null);
          props.setIdInvoice(null);
          if (props.setIdPredracunZaKonacni) props.setIdPredracunZaKonacni(null);
          setIdItem(null);
          setIdService(null);
          setIdTrip(null);
          setIdArtical(null);
          setIzabran(null);
          setPopuni(null);
          resetData();
          resetDataItems();
          resetDataFiles();
          setTableData([]);
          if (wasKonacna) {
            fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token }
            }).then(r => r.json()).then(d => dispatch({ type: 'AVANS_ALARM_SET', value: d?.[0]?.AlarmCount || 0 })).catch(() => {});
          }

          toast.current.show({
            severity: "success",
            summary: "Uspešno pasiviziranje podataka fakture!",
            life: 3000,
          });
        })
        .catch((error) => {
          uzmiGresku(error).then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Niste izabrali fakturu za brisanje!",
        life: 3000,
      });
    }
  };

  const rejectDeleteInvoice = () => {
    console.log("Odbijeno brisanje fakture!");
  };


  const handleSlanjeEFaktura = () => {
    if (!can('FAKTURE', 'edit')) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Nemate odgovarajuću ulogu profila za slanje na SEF!', life: 3000 });
      return;
    }
    if (!idInvoice) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali fakturu za slanje na SEF!', life: 3000 });
      return;
    }
    if (!sefKonfigurisan) {
      toast.current.show({ severity: 'error', summary: t('sef.nijeKonfigurisan'),
        detail: sefRazlog || t('sef.nemaKljucaOpsti'), life: 7000 });
      return;
    }
    if (isHardLocked) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: lockReason, life: 3000 });
      return;
    }
    if (isSefPoslata) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Faktura je već poslata na SEF.', life: 3000 });
      return;
    }
    if (!isStandardnaFaktura) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Na SEF se može slati samo Standardna faktura.', life: 3000 });
      return;
    }
    if (avansniZaPrikaz.length > 0 && avansniZaPrikaz.some(a => !a.sefSalesInvId)) {
      const neposlati = avansniZaPrikaz.filter(a => !a.sefSalesInvId).map(a => a.BrojRacuna || `#${a.ID}`).join(', ');
      toast.current.show({ severity: 'error', summary: 'Avansni račun nije poslat na SEF!',
        detail: `Avansni račun(i) ${neposlati} moraju biti poslati na SEF pre slanja konačnog računa.`, life: 7000 });
      return;
    }
    handleSendToSef();
  };

const handleIzveziPDF = async () => {
  if (!idInvoice) {
    toast.current.show({
      severity: "warn",
      summary: "Upozorenje!",
      detail: "Niste izabrali fakturu za eksport!",
      life: 3000,
    });
    return;
  }
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id: idInvoice, QR: true }),
    };
    const res = await fetch(
      process.env.REACT_APP_BACKEND_URL + "/invoice/PrintInvoice",
      requestOptions
    );
    const data = await res.json();
    if (data && data.htmlContent) {
      await exportInvoiceWithFiles({
        podaci: data,
        token: auth.token,
        fileName: `Faktura_${data.RacunBroj || idInvoice}.pdf`,
      });
    }
  } catch (e) {
    toast.current.show({
      severity: "error",
      summary: "Greška",
      detail: "Neuspešan export PDF-a.",
      life: 3000,
    });
    console.error(e);
  }
};

const handleIzveziExcel = async () => {
  if (!idInvoice) {
    toast.current.show({
      severity: "warn",
      summary: "Upozorenje!",
      detail: "Niste izabrali fakturu kako bi je eksportovali!",
      life: 3000,
    });
    return;
  }
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id: idInvoice, QR: true }),
    };
    const res = await fetch(
      process.env.REACT_APP_BACKEND_URL + "/invoice/PrintInvoice",
      requestOptions
    );
    const data = await res.json();
    if (data && data.htmlContent) {
      const currentVrstaLabel = vrstaFaktureOptions.find(o => o.value === formData.vrstaFakture)?.label || '';
      const isPredracun = /predra/i.test(currentVrstaLabel);
      await exportInvoiceToExcel(data, { token: auth.token, isPredracun }, `Faktura_${data.RacunBroj || idInvoice}.xlsx`);
    }
  } catch (e) {
    toast.current.show({
      severity: "error",
      summary: "Greška",
      detail: "Neuspešan export Excel-a.",
      life: 3000,
    });
    console.error(e);
  }
};

  const invalidControl = (data) => {
    if (!formSubmitted) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

    const invalidControlItems = (data) => {
    if (!formSubmittedItems) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const addDays = (date, days) => {
    if (!date || days === null || days === undefined) return null;
    const d = date instanceof Date ? new Date(date) : new Date(date);
    if (isNaN(d.getTime())) return null;
    const n = Number(days);
    if (Number.isNaN(n)) return null;
    d.setDate(d.getDate() + n);
    return d;
  };

  const resetDataItems = () => {
    voziloStavkeIzBaze.current = null;
    setFormDataItems({
    sifraStavke: null, 
    tekst: "", 
    slobodanTekst: "", 
    jedinicnaCena: null,
    kolicina: null,
    neto: null,
    bruto: null,
    PDVstopa: 0.00,
    PDVIznos: 0.00,
    //VOZILO
    id_vozilo: null,
     // MAGACIN
    id_magacin: null, // *
    artikal: null,
    jedinicaMere: null,
    rabatProc: null,
    rabat: null
  });
  }

  const loadPredracunZaKonacnu = async (id_predracun) => {
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetPredracunZaKonacnu', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ id_predracun }),
      });
      const data = await res.json();
      if (!res.ok || data.message) {
        toast.current.show({ severity: 'error', summary: 'Greška', detail: data.message || 'Greška pri učitavanju predračuna.', life: 5000 });
        return;
      }
      const predracun = data.PredracunDB?.[0];
      const stavke = data.StavkeDB || [];
      const avansni = data.AvansniDB || [];
      setAvansniZaPrikaz(avansni);
      setPredracunStavkeZaIzbor(stavke);
      setSelectedPredracunStavke(stavke);
      setBrojPredracunaPrikaz(predracun?.BrojPredracuna || '');
      if (predracun) setGrupaFakture(predracun.id_grupa_fakture);
      setIdTrip(stavke[0]?.id_from_group || null);

      const kursNum2 = parseFloat(predracun?.kurs) || 1;
      const stavkaVal2 = stavke[0]?.iznosValuta;
      const sumStavki2 = stavke.reduce((s, r) => s + parseFloat(r.iznos || 0), 0);
      const sumAvansi2 = avansni.reduce((s, a) => {
        const ai = parseFloat(a.Iznos || 0);
        if (a.IznosValuta === stavkaVal2) return s + ai;
        if (a.IznosValuta === 220 && stavkaVal2 !== 220) return s + (kursNum2 > 1 ? ai / kursNum2 : ai);
        if (a.IznosValuta !== 220 && stavkaVal2 === 220) return s + ai * kursNum2;
        return s + ai;
      }, 0);
      setFormData(prev => ({
        ...prev,
        id_klijent: predracun?.id_klijent || null,
        vrstaFakture: 300,
        refNasa: predracun?.refNasa || '',
        refNo: predracun?.refNo || '',
        valuta: predracun?.valuta || 220,
        kurs: predracun?.kurs || null,
        tekuciRacun: predracun?.tekuciRacun || null,
        napomenaPoreskoOslobadjanje: predracun?.napomenaPoreskoOslobadjanje || '',
        datum: new Date(),
        dpu: new Date(),
        rokPlacanjaDani: predracun?.rokPlacanjaDani || 0,
        // Iznos = suma svih označenih stavki predračuna
        iznos: parseFloat(sumStavki2.toFixed(2)),
        iznosValuta: stavkaVal2 || predracun?.valuta,
        vozilo: stavke[0]?.vozilo || '',
        cmr: stavke[0]?.cmr || '',
        zemljaUtovara: stavke[0]?.zemljaUtovara || null,
        zemljaIstovara: stavke[0]?.zemljaIstovara || null,
        posiljalac: stavke[0]?.posiljalac || '',
        primalac: stavke[0]?.primalac || '',
        brojTure: stavke[0]?.brojTure || '',
        jci: stavke[0]?.jci || '',
        mestoIzvrsenjaUsluge: stavke[0]?.mestoIzvrsenjaUsluge || '',
        relacija: stavke[0]?.relacija || '',
        roba: stavke[0]?.roba || '',
        datumUtovara: stavke[0]?.datumUtovara ? new Date(stavke[0].datumUtovara) : null,
        datumIstovara: stavke[0]?.datumIstovara ? new Date(stavke[0].datumIstovara) : null,
      }));
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: 'Greška pri učitavanju predračuna za konačnu fakturu.', life: 5000 });
    }
  };

  /* Stavke sa otpremnice — upisuju se tek kad faktura dobije id.

     Sifra je „PRODAJA ROBE" iz sifarnika te firme (procedura je vraca u
     `sifraStavkeProdaja`), jer stavka fakture bez sifre i bez iznosa se ne
     upisuje. Cena dolazi sa stavke otpremnice; ako je u drugoj valuti,
     zajednicki modul je preracuna po srednjem kursu — dinarska faktura je
     uvek u RSD. */
  const upisiStavkeOtpremnice = async (newInvoiceId, stavke, sifraStavke) => {
    const sifra = sifraStavkeOptions.find(x => x.value === sifraStavke);
    const spremne = spremiStavke({
      stavke, sifraStavke, sifra, ciljValuta: RSD, kursevi: props.kurseviOptions,
    });

    const bezKursa = spremne.filter(x => x.greska);
    if (bezKursa.length > 0) {
      toast.current?.show({
        severity: 'warn', summary: t('magacin.cenaBezKursa'), life: 6000,
      });
    }

    const zaUpis = spremne.filter(x => !x.greska);
    const upisano = await upisiStavke({
      token: auth.token,
      idFakture: newInvoiceId,
      stavke: zaUpis,
    });

    /* Broj prenetih stavki se javlja, da operater odmah vidi da li je
       faktura dobila sve što je na otpremnici. */
    toast.current?.show({
      severity: upisano === stavke.length ? 'success' : 'warn',
      summary: t('magacin.preneteStavke', { broj: upisano, ukupno: stavke.length }),
      life: 5000,
    });
  };

  const submitPreostaleKonacneStavke = async (newInvoiceId, preostaleStavke) => {
    for (const s of preostaleStavke) {
      try {
        await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/InsertInvoiceItem', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({
            id: newInvoiceId,
            formDataItems: {
              sifraStavke: s.sifraStavke, tekst: s.tekst, slobodanTekst: s.slobodanTekst,
              jedinicnaCena: s.iznos, kolicina: s.kolicina, neto: s.neto, bruto: s.bruto,
              PDVstopa: s.PDVstopa, PDVIznos: s.PDVIznos, id_magacin: s.id_magacin,
              artikal: s.artikal, id_vozilo: s.id_vozilo, jedinicaMere: s.jedinicaMere,
              rabatProc: s.rabatProc, rabat: s.rabat, id_predracun_stavka: s.id_predracun_stavka,
            },
          }),
        });
      } catch (e) { console.error('Greška pri dodavanju stavke:', e); }
    }
  };

  const resetData = () => {
    setInvoiceStatus(1);
    setIdPredracunVezan(null);
    setAvansniZaPrikaz([]);
    setPredracunStavkeZaIzbor([]);
    setSelectedPredracunStavke([]);
    setBrojPredracunaPrikaz('');
    setFormData({
    fakturaBr: "", // readonly
    id_klijent: null, // *
    vrstaFakture: null, // *
    vozilo: "",
    cmr: "",
    refNasa: "",
    refNo: "",
    iznos: null,
    iznosValuta: "", // "RSD" | "EUR"
    napomenaPoreskoOslobadjanje: "",
    napomena: "",
    datum: null,
    mestoIzdavanja: "", // readonly
    dpu: null, // datum
    rokPlacanjaDani: null,
    rokPlacanjaDatum: null, // dpu + rokPlacanjaDani
    tekuciRacun: null,
    zemljaUtovara: null,
    zemljaIstovara: null,
    posiljalac: "",
    primalac: "",
    brojTure: "", // readonly
    jci: "",
    mestoIzvrsenjaUsluge: "",
    relacija: "", // readonly
    roba: "",
    datumUtovara: null,
    datumIstovara: null,
    valuta: null, // *
    kurs: null, // *
    finansijskiStatus: null, // *
    statusSefa: null, // *
    sefStatusString: null,
    sefKomentar: null,
    datumSlanjaPoste: null,
    datumPrijemaPoste: null,
    DateEntered: null
  });
  }

  const handleChangeItems = () => {
    if(formDataItems.neto != null && formDataItems.PDVstopa != null) {
        setFormDataItems(prev => ({ ...prev, PDVIznos: formDataItems.neto * formDataItems.PDVstopa/100}));
      }
      if(formDataItems.neto != null && formDataItems.PDVIznos != null) {
        setFormDataItems(prev => ({ ...prev, bruto: formDataItems.neto + formDataItems.PDVIznos}));
      }
  }

  const handleChange = (e) => {
    const { name, value } = e.target || e;


if (name in formData) {
      if (name === "iznosValuta") {
        if(formData.datum)
        setFormData(prev => ({ ...prev, kurs: returnCourseForDate(valutaOptions, value, kurseviOptions, formData.datum)}));
            }
      if (name === "datum") {
          if(formData.iznosValuta){
            setFormData(prev => ({ ...prev, kurs: returnCourseForDate(valutaOptions, formData.iznosValuta, kurseviOptions, value)}));
            }
        }

    setFormData((prev) => {
      const next = { ...prev, [name]: value };

      // Rok plaćanja datum = DPU + rokPlacanjaDani
      if (name === "rokPlacanjaDani") {
        next.rokPlacanjaDatum = addDays(
          name === "datum" ? value : prev.datum,
          name === "rokPlacanjaDani" ? value : prev.rokPlacanjaDani
        );
      }

      return next;
    });
  }
  if (name in formDataItems) {
      if(name ==="id_vozilo") {
        if(value){
        let voziloKarakt = vozilaOptions.find(x => x.value === value)
        setFormDataItems(prev => ({ ...prev, tekst: voziloKarakt.KarakteristikeTekst}));}
      }
      if(name === "sifraStavke") {
        if(formDataItems.id_vozilo){
          setFormDataItems(prev => ({ ...prev, id_vozilo: null}))
        }
        let sifra = sifraStavkeOptions.find(x => x.value === value)
        
        if(sifra.value && formDataItems.sifraStavke && sifra.value != formDataItems.sifraStavke){
          setFormDataItems(prev => ({ ...prev, PDVIznos: null}));
          setFormDataItems(prev => ({ ...prev, bruto: null}));
          setFormDataItems(prev => ({ ...prev, PDVstopa: null}));    
        }
          setFormDataItems(prev => ({ ...prev, tekst: sifra.Opis }));
          setFormDataItems(prev => ({ ...prev, PDVstopa: sifra.PDVStopa }));
          setFormDataItems(prev => ({ ...prev, slobodanTekst: sifra.TekstOslobodjenja }));
      }
      if(name === "kolicina" && formDataItems.jedinicnaCena) {
          setFormDataItems(prev => ({ ...prev, neto: value * formDataItems.jedinicnaCena}));
          setFormDataItems(prev => ({ ...prev, PDVIznos: null}));
          setFormDataItems(prev => ({ ...prev, bruto: null}));  
      }
      if(name === "jedinicnaCena" && formDataItems.kolicina) {
          setFormDataItems(prev => ({ ...prev, neto: value * formDataItems.kolicina}));
          setFormDataItems(prev => ({ ...prev, PDVIznos: null}));
          setFormDataItems(prev => ({ ...prev, bruto: null})); 
      }

        setFormDataItems(prev => ({ ...prev, [name]: value}));
  }

  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (isHardLocked) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: lockReason,
        life: 3000,
      });
      return;
    }

    if(!grupaFakture) {
                  toast.current.show({
              severity: "warn",
              summary: "Upozorenje!",
              detail: "Mora biti izabrana grupa fakture!",
              life: 3000,
            });
            return
    }
    if(grupaFakture === 297 && idTrip === null) {
                  toast.current.show({
              severity: "warn",
              summary: "Upozorenje!",
              detail: "Morate pokrenuti kreiranje ture iz radnog naloga. TURE > Radni nalog > Fakture",
              life: 3000,
            });
            return
    }

    setFormSubmitted(true);

    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

      if (
        activeIndex != 0 &&
        (
          formData.id_klijent == null ||
          formData.vrstaFakture == null ||
          (formData.iznos == null && grupaFakture != 334 )||
          formData.iznosValuta == null ||
          formData.datum == null ||
          (grupaFakture == 297 && formData.dpu == null) ||
          formData.rokPlacanjaDani == null ||
          formData.tekuciRacun == null
        )
      ) {
        setActiveIndex(0);
        return;
      }

           if (
        activeIndex != 1 &&
        (
          (grupaFakture == 297 && formData.vozilo == "") ||
          (grupaFakture == 297 && formData.zemljaIstovara == null) ||
          (grupaFakture == 297 && formData.zemljaUtovara == null) ||
          (grupaFakture == 297 &&  formData.posiljalac == "") ||
          (grupaFakture == 297 && formData.primalac == "") ||
          (grupaFakture == 297 && formData.mestoIzvrsenjaUsluge == "") ||
          (grupaFakture == 297 && formData.relacija == "") ||
          (grupaFakture == 297 && formData.datumUtovara ==  null) ||
          (grupaFakture == 297 && formData.datumIstovara ==  null)
        )
      ) {
        setActiveIndex(1);
        return;
      }

            /* Kod prodaje vozila (grupa 334) kartica "Podaci valute" nema sta da
               primi — valuta i kurs se ne unose. Bez ovog izuzetka snimanje je
               bacalo korisnika na praznu karticu i tu ga zaglavljivalo. */
            if (
        activeIndex != 2 && grupaFakture != 334 &&
        (
          formData.valuta == null ||
          formData.kurs == null
        )
      ) {
        setActiveIndex(2);
        return;
      }

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati fakturu?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptSave,
    });
  };

  const popuniStavke = (apiData) => {
    if (!apiData?.FakturaDB?.[0]) {
      toast.current?.show({
        severity: 'warn', summary: t('fakture.podaciNisuStigli'), life: 5000,
      });
      return;
    }

        setButtonDocumentDB({
            uploadedFileInvoice: apiData.ImaDokumentDB?.[0]?.uploadedFileInvoice || 0,
            brojPriloga: apiData.ImaDokumentDB?.[0]?.brojPriloga || 0
        })
     setGrupaFakture(apiData.FakturaDB?.[0].id_grupa_fakture)
     setInvoiceStatus(apiData.FakturaDB?.[0].status === false || apiData.FakturaDB?.[0].status === 0 ? 0 : 1)
    //Ubacivanje TRIPa za edit racuna
     if(apiData.FakturaDB?.[0].id_grupa_fakture == 297 && apiData.FakturaStavkeDB?.[0].id_from_group)
      setIdTrip(apiData.FakturaStavkeDB?.[0].id_from_group)

    // Faktura je KONAČNA za neki predračun — prikaži accordion "Avansni računi"
    const idPredracunLnk = apiData.FakturaDB?.[0].id_predracun || null;
    setIdPredracunVezan(idPredracunLnk);
    if (idPredracunLnk) {
      const stavkePr = apiData.PredracunStavkeDB || [];
      const thisInvoiceId = apiData.FakturaDB?.[0].ID || apiData.FakturaDB?.[0].id;
      // Pre-selektuj stavke koje su već fakturisane ovom konačnom računom
      const veceSelektovane = stavkePr.filter(s => String(s.id_faktura_konacna) === String(thisInvoiceId));
      setAvansniZaPrikaz(apiData.AvansniKonacniDB || []);
      setPredracunStavkeZaIzbor(stavkePr);
      setSelectedPredracunStavke(veceSelektovane.length > 0 ? veceSelektovane : stavkePr);
      setBrojPredracunaPrikaz(apiData.BrojPredracunaDB?.[0]?.BrojPredracuna || '');
    } else {
      setAvansniZaPrikaz([]); setPredracunStavkeZaIzbor([]); setSelectedPredracunStavke([]); setBrojPredracunaPrikaz('');
    }

    setFormData({
        fakturaBr: apiData.FakturaDB?.[0].fakturaBr || '',
        id_klijent: apiData.FakturaDB?.[0].id_klijent || null,
        vrstaFakture: apiData.FakturaDB?.[0].id_vrsta_fakture || null,
        vozilo: apiData.FakturaStavkeDB?.[0]?.vozilo || '',
        cmr: apiData.FakturaStavkeDB?.[0]?.cmr || '',
        refNasa: apiData.FakturaDB?.[0].refNasa || '',
        refNo: apiData.FakturaDB?.[0].refNo || '',
        iznos: apiData.FakturaDB?.[0]?.sumaNeto || 0,
        iznosValuta: apiData.FakturaDB?.[0].valuta || null,
        napomenaPoreskoOslobadjanje: apiData.FakturaDB?.[0].napomenaPoreskoOslobadjanje || '',
        napomena: apiData.FakturaDB?.[0].napomena || '',
        datum: apiData.FakturaDB?.[0].datum ? new Date(apiData.FakturaDB?.[0].datum) : null,
        mestoIzdavanja: apiData.FakturaDB?.[0].MestoIzdavanja || null,
        dpu: apiData.FakturaDB?.[0].dpu ? new Date(apiData.FakturaDB?.[0].dpu) : null,  
        rokPlacanjaDani: apiData.FakturaDB?.[0].rokPlacanjaDani || null,
        rokPlacanjaDatum: addDays(apiData.FakturaDB?.[0].datum,apiData.FakturaDB?.[0].rokPlacanjaDani),
        tekuciRacun: apiData.FakturaDB?.[0].tekuciRacun || null,
        zemljaUtovara: apiData.FakturaStavkeDB?.[0]?.zemljaUtovara || null,
        zemljaIstovara: apiData.FakturaStavkeDB?.[0]?.zemljaIstovara || null,
        posiljalac: apiData.FakturaStavkeDB?.[0]?.posiljalac || '',
        primalac: apiData.FakturaStavkeDB?.[0]?.primalac || '',
        brojTure: apiData.FakturaStavkeDB?.[0]?.brojTure || '',
        jci: apiData.FakturaStavkeDB?.[0]?.jci || '',
        mestoIzvrsenjaUsluge: apiData.FakturaStavkeDB?.[0]?.mestoIzvrsenjaUsluge || '',
        relacija: apiData.FakturaStavkeDB?.[0]?.relacija || '',
        roba: apiData.FakturaStavkeDB?.[0]?.roba || '',
        datumUtovara: apiData.FakturaStavkeDB?.[0]?.datumUtovara ? new Date(apiData.FakturaStavkeDB?.[0]?.datumUtovara) : null,  
        datumIstovara: apiData.FakturaStavkeDB?.[0]?.datumIstovara ? new Date(apiData.FakturaStavkeDB?.[0]?.datumIstovara) : null,  
        valuta: 220,
        kurs: apiData.FakturaDB?.[0].kurs || null,
        finansijskiStatus: apiData.FakturaDB?.[0].finansijskiStatus || null,
        statusSefa: apiData.FakturaDB?.[0].statusSEF ?? apiData.FakturaDB?.[0].statusSefa ?? null,
        sefStatusString: apiData.FakturaDB?.[0].sefStatus ?? null,
        sefKomentar: apiData.FakturaDB?.[0].sefKomentar ?? null,
        datumSlanjaPoste: apiData.FakturaDB?.[0].datumSlanjaPoste ? new Date(apiData.FakturaDB?.[0].datumSlanjaPoste) : null,  
        datumPrijemaPoste: apiData.FakturaDB?.[0].datumPrijemaPoste ? new Date(apiData.FakturaDB?.[0].datumPrijemaPoste) : null, 
        DateEntered: apiData.FakturaDB?.[0].DateEntered ? new Date(apiData.FakturaDB?.[0].DateEntered) : null, 
    });
}

  const popuniRedove = async (id) => {

             setPopuni(true);
             setIzabran(true)
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/FillInInvoiceData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                              
                                /* Prazan odgovor znaci da faktura nije nadjena (obrisana,
                                   tudja firma, prekinuta veza) — bolje jasna poruka nego pad. */
                                if (!Array.isArray(data) || !data[0] || !data[0]["JsonOutput"]) {
                                  toast.current?.show({
                                    severity: 'warn', summary: t('fakture.podaciNisuStigli'), life: 5000,
                                  });
                                  return;
                                }
                                if (!Array.isArray(data) || !data[0] || !data[0]["JsonOutput"]) {
                       toast.current?.show({
                         severity: 'warn', summary: t('fakture.podaciNisuStigli'), life: 5000,
                       });
                       return;
                     }
                     const stringifiedJson = data[0]["JsonOutput"];
                                const parsedData = JSON.parse(stringifiedJson);

                                const preparedData = {
                                    FakturaDB: parsedData.FakturaDB,
                                    FakturaStavkeDB: parsedData.FakturaStavkeDB,
                                    ImaDokumentDB: parsedData.ImaDokumentDB,
                                    AvansniKonacniDB: parsedData.AvansniKonacniDB,
                                    PredracunStavkeDB: parsedData.PredracunStavkeDB,
                                    BrojPredracunaDB: parsedData.BrojPredracunaDB
                                }
                                
                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavke(preparedData)

                                if (preparedData.FakturaDB?.[0]?.status === 0 || preparedData.FakturaDB?.[0]?.status === false) {
                                    toast.current.show({
                                        severity: "warn",
                                        summary: "Stornirana faktura",
                                        detail: "Faktura je stornirana — forma je zaključana, samo za pregled.",
                                        life: 5000,
                                    });
                                }

                                setTableData(parsedData.TableData)

                            if (parsedData.TableData && parsedData.TableData.length > 0) {
                              const columns = Object.keys(parsedData.TableData[0])
                                .filter(key => !['ID'].includes(key))
                                .map(key => ({
                                label: key,
                                value: key
                                }));
                      
                              
                              setAllColumns(columns);
                              // const originalOrder = Object.keys(parsedData.TableData[0]);
                              // setOriginalColumnOrder(originalOrder);
                              
                                  // const columnsDB = await getConfigColumnsTrip();

                                  // if (!columnsDB.empty && columnsDB.data.length > 0) {
                                  //   let arr;

                                  //     if(typeof columnsDB?.parsedData.TableData?.[0]?.parametri === "string")
                                  //     arr = JSON.parse(columnsDB.data[0].parametri);
                                  //     else
                                  //     arr = columnsDB.data[0].parametri;

                                  //   setSelectedColumns(arr);
                                  // } else {
                              
                                  // }
                                        setSelectedColumns(columns.slice(0, 12).map(col => col.value));
                            }
                            
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
          
    }


  // ─── SEF helper ──────────────────────────────────────────────────────────────
  const currentInvoiceId = props.idInvoice || idInvoice;

  const navIndex = navList.findIndex(x => String(x.id) === String(currentInvoiceId));
  const canGoPrev = navIndex > 0;
  const canGoNext = navIndex >= 0 && navIndex < navList.length - 1;

  const handleNavigateInvoice = (smer) => {
    const target = navList[navIndex + smer];
    if (!target) return;

    if (!target.isDinarska) {
      props.setChangeView(2);
    }
    props.setIdInvoice(target.id);
  };

  /* Mistake = „greska prilikom slanja“ iz SEF dokumentacije. Ranije je ovde
     stajao nas interni marker 'SendingError', koji SEF nikad ne vraca, pa se
     neuspelo poslata faktura nije mogla otkazati. */
  const SEF_CANCEL_STATUSI = ['Draft', 'New', 'Mistake', 'SendingError'];
  const SEF_STORNO_STATUSI = ['Sent', 'Approved', 'Rejected'];

  const sefApiCall = async (endpoint, body = {}) => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/sef/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || 'Greška pri komunikaciji sa SEF-om.');
    }
    return res.json();
  };

  const handleSendToSef = () => {
    const brojPriloga = buttonDocumentDB.brojPriloga || 0;
    const porukaPrilozi = brojPriloga > 0
      ? ` Faktura ima ${brojPriloga} ${brojPriloga === 1 ? 'prilog' : 'priloga'} koji će biti poslat zajedno sa fakturom.`
      : '';
    confirmDialog({
      message: 'Da li ste sigurni da želite da pošaljete fakturu na SEF?' + porukaPrilozi,
      header: 'Potvrda slanja na SEF',
      icon: 'pi pi-send',
      style: { maxWidth: '50vw' },
      acceptLabel: 'Pošalji',
      rejectLabel: 'Odustani',
      accept: async () => {
        if (!sefKonfigurisan) {
          toast.current.show({ severity: 'error', summary: t('sef.nijeKonfigurisan'),
            detail: sefRazlog || t('sef.nemaKljucaOpsti'), life: 7000 });
          return;
        }
        setSefLoading(true);
        try {
          await sefApiCall('SendInvoice', { id_faktura: currentInvoiceId });
          toast.current.show({ severity: 'success', summary: 'Faktura poslata na SEF.', life: 4000 });
          setFormData(prev => ({ ...prev, statusSefa: 219, sefStatusString: 'New' }));
        } catch (e) {
          toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message, life: 5000 });
        } finally {
          setSefLoading(false);
        }
      }
    });
  };

  const handleCancelSef = () => {
    setSefDialog({ visible: true, type: 'cancel', komentar: '' });
  };

  const handleStornoSef = () => {
    setSefDialog({ visible: true, type: 'storno', komentar: '' });
  };

  const executeSefAction = async () => {
    setSefDialog(prev => ({ ...prev, visible: false }));
    setSefLoading(true);
    try {
      if (sefDialog.type === 'cancel') {
        await sefApiCall('CancelInvoice', { id_faktura: currentInvoiceId, cancelComments: sefDialog.komentar });
        toast.current.show({ severity: 'success', summary: 'Faktura otkazana na SEF-u.', life: 4000 });
        setFormData(prev => ({ ...prev, statusSefa: 218, sefStatusString: 'Cancelled' }));
      } else {
        await sefApiCall('StornoInvoice', { id_faktura: currentInvoiceId, stornoComment: sefDialog.komentar });
        toast.current.show({ severity: 'success', summary: 'Faktura stornirana na SEF-u.', life: 4000 });
        setFormData(prev => ({ ...prev, statusSefa: 218, sefStatusString: 'Storno' }));
      }
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message, life: 5000 });
    } finally {
      setSefLoading(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────────

  const acceptSave = async () => {

    try {
       const hasAnyValueFiles = Object.values(formDataFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                if (Array.isArray(value)) {
                    return value.length > 0 && value.some(item => item !== null && item !== '');
                }
                return true;
            });
            // Forma prikazuje sumu svih stavki (za pregled), ali backend za PRVU stavku dobija
            // njen individualni iznos iz predračuna — ostale stavke idu kroz submitPreostaleKonacneStavke.
            const prvaStavkaIznos = props.idPredracunZaKonacni && selectedPredracunStavke[0]
              ? parseFloat(selectedPredracunStavke[0].iznos || 0)
              : formData.iznos;
            const payload = {
                        ...formData,
                        /* Stavke stižu sa otpremnice, pa procedura ne sme da napravi i svoju
                           prvu stavku iz zaglavlja — bila bi duplirana. */
                        bezPrveStavke: stavkeOtpremnice.length > 0 ? 1 : 0,
                        iznos: prvaStavkaIznos,
                        datum: toUtcIso(formData.datum),
                        datumUtovara: toUtcIso(formData.datumUtovara),
                        datumIstovara: toUtcIso(formData.datumIstovara),
                        datumPrijemaPoste: toUtcIso(formData.datumPrijemaPoste),
                        datumSlanjaPoste: toUtcIso(formData.datumSlanjaPoste),
                        dpu: toUtcIso(formData.dpu),
                        id_predracun: props.idPredracunZaKonacni || null,
                        id_predracun_stavka: props.idPredracunZaKonacni
                          ? (selectedPredracunStavke[0]?.id_predracun_stavka || null)
                          : null,
                        };

                if(props.idInvoice || izabran){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: props.idInvoice ? props.idInvoice : idInvoice,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/UpdateInvoice", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima fakture.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima fakture.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
  
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka fakture!",
                                life: 3000,
                                });
                                }
                                setFormSubmitted(false)
                                resetDataFiles()
                                popuniRedove(idInvoice)
                                if(idInvoice && (hasAnyValueFiles)) {
                                handleUploadAndSaveFiles(invoice)
                                }
                                
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                idTrip,
                                formData: payload,
                                tipFakture,
                                podTipFakture,
                                grupaFakture
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/InsertInvoice", requestOptions)
                            .then(handleErrors)
                            .then(async (data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }
                                setFormSubmitted(false)
                                // Bug 2: dodaj SVE ostale odabrane stavke predračuna (slice(1))
                                if (props.idPredracunZaKonacni && selectedPredracunStavke.length > 1) {
                                  await submitPreostaleKonacneStavke(data.id, selectedPredracunStavke.slice(1));
                                }
                                /* Stavke sa otpremnice idu odmah posle zaglavlja, pa ih
                                   operater zatekne u tabeli i samo upiše cene. */
                                if (stavkeOtpremnice.length > 0) {
                                  await upisiStavkeOtpremnice(data.id, stavkeOtpremnice, sifraProdajeRobe);
                                  setStavkeOtpremnice([]);
                                }
                                // Bug 1: ne resetuj sve kad dolazimo s predračuna — popuniRedove osvježava
                                if (!props.idPredracunZaKonacni) resetData();
                                setIdInvoice(data?.id)
                                fetchNavList()
                                popuniRedove(data?.id)
                                if (props.idPredracunZaKonacni) {
                                  fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
                                    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token }
                                  }).then(r => r.json()).then(d => dispatch({ type: 'AVANS_ALARM_SET', value: d?.[0]?.AlarmCount || 0 })).catch(() => {});
                                }
                                if((data.id) && (hasAnyValueFiles)) {

                                handleUploadAndSaveFiles(data.id)
                                }

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka fakture!",
                                life: 3000,
                                });
                              
                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje (TODO).",
        life: 3000,
      });
    }
  };

  const openModalItems = () => {
    if (isLocked) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: lockReason,
        life: 3000,
      });
      return;
    }
    if(idInvoice || props.idInvoice) {
    resetDataItems();
    setConfirmVisible(true);
    } else {
       toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Unesite ili izaberite fakturu pa nastavite sa unosom stavki!",
        life: 3000,
      });
      return
    }
  }

      /* Isti oblik kao na ulaznim fakturama, KO/KZ i stavkama izvoda:
         radnje levo, pretraga desno, u jednom redu. */
      const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                  {/* Naknadno dodavanje stavki samo na prodaji vozila (334). Transport,
                      magacin i servis stavke dobijaju iz svojih modula (Ture, Magacin,
                      Servis) — ručno dodata stavka bi se razišla sa nalogom/otpremnicom. */}
                  <Button type="button" icon="pi pi-plus" severity="info" rounded
                      disabled={Number(grupaFakture) !== 334}
                      onClick={openModalItems} data-pr-tooltip={t('nova.novaStavka')} />
              </div>
              <input type="search" placeholder={t('nova.phPretraga')}
                  className="p-inputtext p-component"
                  onInput={(e) => setGlobalFilter(e.target.value)} />
          </div>
      );

    const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };


    const chooseItem = async (rowData) => {    
      const id = getId(rowData);
  
  
      setSelectedRowId((prev) => {
        const next = String(prev) === String(id) ? null : String(id);
  
      if (next) {
        // selekcija
        const tripID = props.tripsDB?.find(t => String(t.ID) === String(rowData.Izaberi));
        if (tripID) {
          props.setIdTrip(tripID);
          props.setIzabran(true);
        }
        
      } else {
        // deselekcija
        props.setIdTrip(null);
        props.setIzabran(false);
      }
  
      return next;
    });
    
    setIdItem(id)

    }

    useEffect(()=> {

      if (idItem) {
          let requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + auth.token,
                },
                body: JSON.stringify({
                  id: idItem
                }),
              };
              
              fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/GetItemData", requestOptions)
                .then(handleErrors)
                .then((data) => {
                  
                  
                     if (!Array.isArray(data) || !data[0] || !data[0]["JsonOutput"]) {
                       toast.current?.show({
                         severity: 'warn', summary: t('fakture.podaciNisuStigli'), life: 5000,
                       });
                       return;
                     }
                     const stringifiedJson = data[0]["JsonOutput"];
                                const parsedData = JSON.parse(stringifiedJson);

                                const preparedData = {
                                    StavkeDB: parsedData.StavkeDB
                                }

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavkeItems(preparedData)

                    setConfirmVisible(true)
                })
                .catch((error) => {
                  uzmiGresku(error).then((errorMessage) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: errorMessage.message,
                      life: 3000,
                    });
                    console.log(errorMessage);
                  });
                });
          }

    },[idItem])

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
  
      const selected = isSelected(rowData);
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
                tooltip="Izaberi stavku fakture za dalji rad"
                tooltipOptions={{ position: 'top' }}
              />
            
        </div>
      );
    };

  const saveItems = (x) => {

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati stavku fakture?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptSaveItems(x),
    });
  };

  const acceptSaveItems = async (x) => {

    try {

            if(idItem){
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/UpdateInvoiceItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima stavke.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima stavke.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka stavke!",
                                life: 3000,
                                });
                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                      if (props.idInvoice || idInvoice) {
                                            popuniRedove(props.idInvoice || idInvoice)
                                          }
                                }
                                setFormSubmittedItems(false)
                                }  
                               
                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                if(idInvoice) {
                  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idInvoice,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/InsertInvoiceItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                  if (idInvoice) {
                                       popuniRedove(idInvoice)
                                      }
                                }
                                resetDataItems();
                                setFormSubmittedItems(false)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka stavke fakture!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije mogući unos stavke, nije uspešno vezana za fakturu!",
                    life: 3000,
                  });
                }
                          
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje stavke.",
        life: 3000,
      });
    }
  };

  const handleFormRemoveItems = () => {
    if (isLocked) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: lockReason,
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: "Jel ste sigurni da želite pasivizirati stavku fakture?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptRemoveItems,
    });
  }

  const acceptRemoveItems = async () => {

     if(idItem){
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/DeleteInvoiceItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data.message){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: "Upozorenje!",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                setFormSubmittedItems(false)
                                setConfirmVisible(false)
                                if(props.idInvoice || idInvoice){
                                  popuniRedove(props.idInvoice || idInvoice)
                                }

                                toast.current.show({
                                    severity: "success",
                                    summary: "Uspešno!",
                                    detail: "Uspešno ste pasivizirali stavku fakture!",
                                    life: 3000,
                                    });
                            })
                            .catch((error) => {
                            uzmiGresku(error).then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else{ 
                  toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije obrisana stavka fakture, nije uspešno vezana za fakturu!",
                    life: 3000,
                  });
            }

  }

  const handleFormSubmitItems = (x) => {

                if (isLocked) {
                    toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: lockReason,
                        life: 3000,
                    });
                    return;
                }
                    setFormSubmittedItems(true)
                if (formRefItems.current && !formRefItems.current.checkValidity()) {
                    formRefItems.current.reportValidity(); // prikazuje native browser poruke
                    return;
                }

                /* Padajuci izbori ne ucestvuju u native validaciji, pa se obavezna
                   polja stavke robe proveravaju izricito. */
                if (grupaFakture == 298 &&
                    (!formDataItems.id_magacin || !formDataItems.artikal || !formDataItems.jedinicaMere)) {
                    toast.current.show({
                        severity: 'warn',
                        summary: t('common.upozorenje'),
                        detail: t('nova.stavkaRobeObavezna'),
                        life: 4000,
                    });
                    return;
                }
       saveItems(x)
     }

  const handleChangeGrupa = (e) => {
    const { value } = e.target || e;
    setGrupaFakture(value); 
    
    resetData();
    resetDataItems();
    resetDataFiles();
    setIdInvoice(null);
    setIdItem(null);
    setIdService(null);
    setIdTrip(null);
    setIdArtical(null);
    setTableData([])
  }

  return (
    <div className="p-fluid grid formUnosZap" style={{ maxWidth: "99%" }}>
      <Toast ref={toast} />
      <ConfirmDialog />

      <Dialog
        visible={sefDialog.visible}
        onHide={() => setSefDialog(prev => ({ ...prev, visible: false }))}
        header={sefDialog.type === 'cancel' ? 'Otkazivanje SEF fakture' : 'Storno SEF fakture'}
        style={{ width: '420px' }}
        footer={
          <div>
            <Button
              label={t('nova.odustani')}
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setSefDialog(prev => ({ ...prev, visible: false }))}
            />
            <Button
              label={sefDialog.type === 'cancel' ? 'Otkaži na SEF-u' : 'Storniraj'}
              icon={sefDialog.type === 'cancel' ? 'pi pi-times-circle' : 'pi pi-exclamation-triangle'}
              className="p-button-danger"
              onClick={executeSefAction}
              disabled={sefLoading}
            />
          </div>
        }
      >
        <p style={{ marginBottom: '1rem' }}>
          {sefDialog.type === 'cancel'
            ? 'Da li ste sigurni da želite da OTKAŽETE fakturu na SEF-u?'
            : 'Da li ste sigurni da želite da STORNIRATE fakturu na SEF-u? Ova akcija je nepovratna.'}
        </p>
        <label>{sefDialog.type === 'cancel' ? t('nova.razlogOtkazivanja')+':' : t('nova.komentarStorniranja')+':'}</label>
        <InputTextarea
          value={sefDialog.komentar}
          onChange={(e) => setSefDialog(prev => ({ ...prev, komentar: e.target.value }))}
          rows={3}
          style={{ width: '100%', marginTop: '0.5rem' }}
          autoFocus
        />
      </Dialog>

      <Dialog
        visible={prilogModalVisible}
        onHide={() => setPrilogModalVisible(false)}
        header={t('nova.priloziFaktura')}
        style={{ width: '900px' }}
        footer={
          <Button label={t('common.close')} icon="pi pi-times" className="p-button-text" onClick={() => setPrilogModalVisible(false)} />
        }
      >
        <DataTable
          value={prilozi}
          className="mb-3"
          showGridlines
          stripedRows
          size="small"
          scrollable
          scrollHeight="40vh"
          emptyMessage="Nema priloga."
        >
          <Column header={t('nova.dokument')} body={rowData => {
            const documentUrl = getDocumentLocation(rowData.Prilog);
            const fileName = rowData.Prilog?.split('/').pop();
            return documentUrl ? (
              <Button label={fileName} icon="pi pi-eye" className="p-button-text p-button-sm"
                onClick={() => window.open(documentUrl, '_blank')} />
            ) : null;
          }} />
          <Column header={t('nova.vrstaDokumenta')} style={{ width: '220px' }} body={rowData => (
            <Dropdown
              value={rowData.id_vrsta_dokumenta}
              options={vrstaDokumentaOptions}
              optionLabel="opis"
              optionValue="id"
              placeholder={t('nova.phVrstu')}
              style={{ width: '100%' }}
              disabled={isLocked}
              onChange={(e) => handlePrilogVrstaChange(rowData, e.value)}
            />
          )} />
          <Column header={t('nova.opis')} body={rowData => (
            <InputText
              value={rowData.Opis || ''}
              style={{ width: '100%' }}
              readOnly={isLocked}
              onChange={(e) => !isLocked && handlePrilogOpisChange(rowData, e.target.value)}
              onBlur={() => !isLocked && handlePrilogOpisBlur(rowData)}
            />
          )} />
          <Column header={`Slanje SEF (${prilozi.filter(p => p.SlanjeNaSef).length}/${MAX_PRILOGA_SEF})`} style={{ width: '140px', textAlign: 'center' }} body={rowData => (
            <input
              type="checkbox"
              checked={!!rowData.SlanjeNaSef}
              disabled={isLocked || (!rowData.SlanjeNaSef && prilozi.filter(p => p.SlanjeNaSef).length >= MAX_PRILOGA_SEF)}
              onChange={(e) => handlePrilogSefChange(rowData, e.target.checked)}
            />
          )} />
          {!isLocked && (
            <Column header="" style={{ width: '50px', textAlign: 'center' }} body={rowData => (
              <Button icon="pi pi-trash" className="p-button-text p-button-danger p-button-sm"
                onClick={() => handleDeletePrilog(rowData)} />
            )} />
          )}
        </DataTable>

        {!isLocked && (
          <FileUpload
            name="uploadedFileInvoice"
            customUpload={true}
            uploadHandler={(e) => { uploadPriloziNow(currentInvoiceId, e.files); e.options.clear(); }}
            multiple
            auto={true}
            mode="basic"
            chooseLabel="Dodaj fajl"
            accept=".pdf,.jpg,.png"
            maxFileSize={5000000}
            disabled={prilogUploading}
          />
        )}
      </Dialog>

            <ConfirmationModalFaktura
                visible={confirmVisible}
                onHide={() => {setConfirmVisible(false);setIdItem(null);setIzabran(false);setSelectedRowId(null);popuniRedove(props.idInvoice ? props.idInvoice : idInvoice)}}
                onConfirmContinue={() => {handleFormSubmitItems(false)}}
                onConfirmExit={() => {handleFormSubmitItems(true)}}
                onConfirmRemove={handleFormRemoveItems}
                idItem={idItem}
            >
              <form autoComplete="off" ref={formRefItems}  style={{ display:'flex', flexWrap: 'wrap' }}>
              <div style={{maxWidth:'49%'}}>
                  
                  <div className="col-12 md:col-3 stavkaField">
                    <label htmlFor="sifraStavke">{t('nova.sifraStavke')}: <span className="iz-obavezno">*</span></label>
                      <CustomDropdown
                        id="sifraStavke"
                        name="sifraStavke"
                        optionLabel="label"
                        required
                        disabled={isLocked}
                        invalid={invalidControlItems(formDataItems.sifraStavke)}
                        value={formDataItems.sifraStavke}
                        options={sifraStavkeOptions}
                        onChange={handleChange}
                        placeholder={t('nova.phSifru')}
                      />
                  </div>
                  <div className="col-12 md:col-6 stavkaField">
                    <label htmlFor="id_vozilo">{t('nova.vozilo')}: {grupaFakture == 334 && <span className="iz-obavezno">*</span>}</label>
                    <CustomDropdown
                      id="id_vozilo"  
                      name="id_vozilo"
                      optionLabel="label"
                      required={grupaFakture == 334}
                      invalid={grupaFakture == 334 ? invalidControlItems(formDataItems.id_vozilo) : null}
                      disabled={isLocked || grupaFakture != 334}
                      value={formDataItems.id_vozilo}
                      options={(vozilaOptions || []).map(o => (o.aktivno === 0
                        ? { ...o, label: `${o.label} (${t('nova.voziloNeaktivno')})` } : o))}
                      /* Neaktivno vozilo (prodato, preneto/odjavljeno) je u spisku samo da bi se
                         postojeća stavka prepoznala — za novu stavku se ne može izabrati. */
                      optionDisabled={o => o.aktivno === 0
                        && String(o.value) !== String(formDataItems.id_vozilo)
                        && String(o.value) !== String(voziloStavkeIzBaze.current)}
                      onChange={handleChange}
                      placeholder={t('nova.phVozilo')}
                    />
                  </div>
                  {/* Magacin, artikal i jedinica mere dolaze sa otpremnice. Na grupi
                      „Faktura magacin" su otvoreni za ispravku i obavezni — stavka
                      robe bez njih ne znaci nista. Na svim ostalim grupama su
                      zakljucani: tamo nemaju sta da traze. */}
                  <div className="col-12 md:col-6 stavkaField">
                    <label htmlFor="id_magacin">{t('nova.magacin')}: {grupaFakture == 298 && <span className="iz-obavezno">*</span>}</label>
                    <CustomDropdown
                      id="id_magacin"
                      name="id_magacin"
                      optionLabel="label"
                      disabled={isLocked || Number(grupaFakture) !== 298}
                      required={grupaFakture == 298}
                      invalid={grupaFakture == 298 ? invalidControlItems(formDataItems.id_magacin) : null}
                      value={formDataItems.id_magacin}
                      options={magacinOptions}
                      onChange={handleChange}
                      placeholder={t('nova.phMagacin')}
                    />
                  </div>
                  <div className="col-12 md:col-6  stavkaField">
                    <label htmlFor="artikal">{t('nova.artikal')}: {grupaFakture == 298 && <span className="iz-obavezno">*</span>}</label>
                    <CustomDropdown
                      id="artikal"
                      name="artikal"
                      optionLabel="label"
                      disabled={isLocked || Number(grupaFakture) !== 298}
                      required={grupaFakture == 298}
                      invalid={grupaFakture == 298 ? invalidControlItems(formDataItems.artikal) : null}
                      value={formDataItems.artikal}
                      options={artikalOptions}
                      onChange={handleChange}
                      placeholder={t('nova.phArtikal')}
                    />
                  </div>
                  <div className="col-12 md:col-6 stavkaField">
                    <label htmlFor="jedinicaMere">{t('nova.jedinicaMere')}: {grupaFakture == 298 && <span className="iz-obavezno">*</span>}</label>
                    <CustomDropdown
                      id="jedinicaMere"
                      name="jedinicaMere"
                      optionLabel="label"
                      disabled={isLocked || Number(grupaFakture) !== 298}
                      required={grupaFakture == 298}
                      invalid={grupaFakture == 298 ? invalidControlItems(formDataItems.jedinicaMere) : null}
                      value={formDataItems.jedinicaMere}
                      options={jedinicaMereOptions}
                      onChange={handleChange}
                      placeholder={t('nova.phJedinicu')}
                    />
                  </div>

                  <div className="col-12 md:col-6 stavkaField">
                    <label htmlFor="tekst">
                      Tekst:
                    </label>
                    <InputTextarea
                      id="tekst"
                      name="tekst"
                      disabled={isLocked}
                      value={formDataItems.tekst}
                      onChange={handleChange}
                      rows={3}
                    />
                  </div>
            </div>          
            <div style={{maxWidth:'25%'}}>
                <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="jedinicnaCena">{t('nova.jedinicnaCena')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="jedinicnaCena"
                  name="jedinicnaCena"
                  required
                  disabled={isLocked}
                  invalid={invalidControlItems(formDataItems.jedinicnaCena)}
                  value={formDataItems.jedinicnaCena}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="kolicina">{t('nova.kolicina')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="kolicina"
                  name="kolicina"
                  required
                  disabled={isLocked}
                  invalid={invalidControlItems(formDataItems.kolicina)}
                  value={formDataItems.kolicina}
                  onValueChange={handleChange}
                  min={1}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="neto">{t('nova.neto')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="neto"
                  name="neto"
                  required
                  disabled={isLocked}
                  invalid={invalidControlItems(formDataItems.neto)}
                  value={formDataItems.neto}
                  onFocus={handleChangeItems}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="PDVstopa">{t('nova.pdvStopa')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="PDVstopa"
                  name="PDVstopa"
                  value={formDataItems.PDVstopa}
                  min={0}
                  max={100}
                  disabled={isLocked}
                  required
                  invalid={invalidControlItems(formDataItems.PDVstopa)}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="PDVIznos">{t('nova.pdvIznos')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="PDVIznos"
                  name="PDVIznos"
                  value={formDataItems.PDVIznos}
                  onFocus={handleChangeItems}
                  disabled={isLocked}
                  required
                  invalid={invalidControlItems(formDataItems.PDVIznos)}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="bruto">{t('nova.bruto')}: <span className="iz-obavezno">*</span></label>
                <InputNumber
                  id="bruto"
                  name="bruto"
                  value={formDataItems.bruto}
                  onFocus={handleChangeItems}
                  disabled={isLocked}
                  required
                  invalid={invalidControlItems(formDataItems.bruto)}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
            </div>
            <div style={{maxWidth:'25%'}}>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="rabatProc">{t('nova.rabatProc')}:</label>
                <InputNumber
                  id="rabatProc"
                  name="rabatProc"
                  min={0}
                  max={100}
                  disabled={isLocked || grupaFakture != 298}
                  value={formDataItems.rabatProc}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="col-12 md:col-3 stavkaFieldInput">
                <label htmlFor="neto">{t('nova.rabat')}:</label>
                <InputNumber
                  id="rabat"
                  name="rabat"
                  disabled={isLocked || grupaFakture != 298}
                  value={formDataItems.rabat}
                  onValueChange={handleChange}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>

            </div>
            <div className="col-12 stavkaField" style={{flexDirection:'column',maxWidth:'100%'}}>
              <label htmlFor="slobodanTekst">
                Slobodan tekst:
              </label>
              <InputTextarea
                id="slobodanTekst"
                name="slobodanTekst"
                disabled={isLocked}
                value={formDataItems.slobodanTekst}
                onChange={handleChange}
                rows={3}
              />
            </div>
            </form>
          </ConfirmationModalFaktura>
      {/* OPCIJE TOOLBAR */}
      <div className="col-12 novaDinarskaIzlazneHeader">
        <div className="col-12 md:col-3" style={{ maxWidth: "fit-content" }}>
          <label htmlFor="grupaFakture">{t('nova.grupaFakture')}: <span className="iz-obavezno">*</span></label>
          <Dropdown
            id="grupaFakture"
            name="grupaFakture"
            required
            invalid={invalidControl(grupaFakture)}
            value={grupaFakture}
            options={grupaFaktureOptionsPonudjene}
            onChange={handleChangeGrupa}
            placeholder={t('nova.phGrupu')}
            disabled={isLocked}
          />
        </div>
        {currentInvoiceId && (
          <div style={{ display: 'flex', gap: '0.3rem' }}>
            <Button
              type="button"
              icon="pi pi-chevron-left"
              disabled={!canGoPrev}
              tooltip="Prethodna faktura"
              tooltipOptions={{ position: 'top' }}
              style={{ padding: '0.2rem 0.5rem', maxHeight: '30px' }}
              onClick={() => handleNavigateInvoice(-1)}
            />
            <Button
              type="button"
              icon="pi pi-chevron-right"
              disabled={!canGoNext}
              tooltip="Sledeća faktura"
              tooltipOptions={{ position: 'top' }}
              style={{ padding: '0.2rem 0.5rem', maxHeight: '30px' }}
              onClick={() => handleNavigateInvoice(1)}
            />
          </div>
        )}
        <Button label={t('nova.stampa')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleStampaj} />
        <Button
          label={t('nova.storno')}
          type="button"
          className="p-button-danger"
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleStorno}
          disabled={isLocked}
        />
        <Button
          label={`Prilozi (${buttonDocumentDB.brojPriloga})`}
          type="button"
          className={buttonDocumentDB.uploadedFileInvoice && classDocumentDB}
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={() => { fetchPrilozi(currentInvoiceId); setPrilogModalVisible(true); }}
          disabled={!currentInvoiceId}
        />
        {idDrzava == 1 && (
          <Button
            label={t('nova.slanjeEFaktura')}
            type="button"
            className="p-button-success"
            style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
            onClick={handleSlanjeEFaktura}
            disabled={sefLoading || isHardLocked || isSefPoslata || !isStandardnaFaktura}
          />
        )}
        {currentInvoiceId && sefKonfigurisan && SEF_CANCEL_STATUSI.includes(formData.sefStatusString) && (
          <Button
            label={sefLoading ? 'Obrada...' : 'Otkaži SEF'}
            type="button"
            className="p-button-warning"
            style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
            onClick={handleCancelSef}
            disabled={sefLoading || isHardLocked}
          />
        )}
        {currentInvoiceId && sefKonfigurisan && SEF_STORNO_STATUSI.includes(formData.sefStatusString) && (
          <Button
            label={sefLoading ? 'Obrada...' : 'Storniraj SEF'}
            type="button"
            className="p-button-danger"
            style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
            onClick={handleStornoSef}
            disabled={sefLoading || isHardLocked}
          />
        )}
        <Button label={t('nova.izveziPdf')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleIzveziPDF} />
        <Button
          label={t('nova.izveziExcel')}
          type="button"
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleIzveziExcel}
        />
      </div>
      {isLocked && (
        <div className="col-12" style={{ padding: '0.6rem 1rem', marginLeft: '1%', marginBottom: '1%', maxWidth: 'fit-content', borderRadius: '4px', fontWeight: 'bold', ...lockStyle }}>
          {lockReason}
        </div>
      )}
      <form
        autoComplete="off"
        ref={formRef}
        className="col-12 novaDinarskaIzlazneForm"
        style={isHardLocked ? { opacity: 0.6 } : undefined}
      >
        {/* OSNOVNO */}
        <Accordion className='' multiple  activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.osnovniPodaci')}>

          <div className="gridFakture">
            <div className="col-12 md:col-3">
              <label htmlFor="fakturaBr">{t('nova.fakturaBr')}:</label>
              <InputText
                id="fakturaBr"
                name="fakturaBr"
                readOnly
                style={{ backgroundColor: "#efefef" }}
                value={formData.fakturaBr}
              />
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="id_klijent">{t('nova.klijent')}: <span className="iz-obavezno">*</span></label>
              <CustomDropdown
                id="id_klijent"
                name="id_klijent"
                optionLabel="label"
                required
                disabled={isLocked}
                invalid={invalidControl(formData.id_klijent)}
                value={formData.id_klijent}
                options={klijentiOptions}
                onChange={handleChange}
                placeholder={t('nova.phKlijenta')}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="vrstaFakture">{t('nova.vrstaFakture')}: <span className="iz-obavezno">*</span></label>
              <Dropdown
                id="vrstaFakture"
                name="vrstaFakture"
                required
                disabled={isLocked || !!props.idPredracunZaKonacni}
                invalid={invalidControl(formData.vrstaFakture)}
                value={formData.vrstaFakture}
                options={vrstaFaktureOptions}
                onChange={handleChange}
                placeholder={t('nova.phVrstu')}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="refNasa">{t('nova.nasaRef')}:</label>
              <InputText
                id="refNasa"
                name="refNasa"
                disabled={isLocked}
                value={formData.refNasa}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="refNo">Ref No:</label>
              <InputText
                id="refNo"
                name="refNo"
                disabled={isLocked}
                value={formData.refNo}
                onChange={handleChange}
              />
            </div>

            {/* Iznos sa naloga + valuta RSD/EUR */}
            <div className="col-12 md:col-3">
              <label htmlFor="iznos">{t('nova.iznos')}: {grupaFakture != 334 && <span className="iz-obavezno">*</span>}</label>
              <InputNumber
                id="iznos"
                name="iznos"
                value={formData.iznos}
                disabled
                required={grupaFakture != 334}
                invalid={grupaFakture != 334 ? invalidControl(formData.iznos) : null}
                onValueChange={handleChange}
                minFractionDigits={2}
                maxFractionDigits={2}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="iznosValuta">{t('nova.valuta')}: <span className="iz-obavezno">*</span></label>
              <CustomDropdown
                id="iznosValuta"
                name="iznosValuta"
                value={formData.iznosValuta}
                options={valutaOptions || []}
                required
                disabled={isLocked}
                invalid={invalidControl(formData.iznosValuta)}
                onChange={handleChange}
                placeholder={t('nova.phValutu')} 
                optionLabel="label"
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="datum">{t('nova.datum')}: <span className="iz-obavezno">*</span></label>
              <Calendar
                id="datum"
                name="datum"
                value={formData.datum}
                onChange={handleChange}
                required
                disabled={isLocked}
                invalid={invalidControl(formData.datum)}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="mestoIzdavanja">{t('nova.mestoIzdavanja')}:</label>
              <InputText
                id="mestoIzdavanja"
                name="mestoIzdavanja"
                onChange={handleChange}
                value={formData.mestoIzdavanja}
                disabled
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="dpu">DPU:</label>
              <Calendar
                id="dpu"
                name="dpu"
                value={formData.dpu}
                onChange={handleChange}
                disabled={isLocked}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="rokPlacanjaDani">{t('nova.rokPlacanjaDani')}: <span className="iz-obavezno">*</span></label>
              <InputNumber
                id="rokPlacanjaDani"
                name="rokPlacanjaDani"
                value={formData.rokPlacanjaDani}
                required
                disabled={isLocked}
                invalid={invalidControl(formData.rokPlacanjaDani)}
                onValueChange={handleChange}
                min={0}
                max={365}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="rokPlacanjaDatum">{t('nova.rokPlacanjaDatum')}:</label>
              <Calendar
                id="rokPlacanjaDatum"
                name="rokPlacanjaDatum"
                value={formData.rokPlacanjaDatum}
                onChange={handleChange}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
                disabled
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="tekuciRacun">{t('nova.tekuciRacun')}: <span className="iz-obavezno">*</span></label>
              <CustomDropdown
                id="tekuciRacun"
                optionLabel="label"
                name="tekuciRacun"
                required
                disabled={isLocked}
                invalid={invalidControl(formData.tekuciRacun)}
                value={formData.tekuciRacun}
                options={tekuciRacunOptions || []}
                onChange={handleChange}
                placeholder={t('nova.phRacun')}
              />
            </div>
            <div className="col-12 md:col-6">
              <label htmlFor="referent">{t('nova.referent')}:</label>
              <Dropdown
                id="referent"
                name="referent"
                disabled
                options={referentiOptions}
                value={user.userId}
              />
            </div>
             <div className="col-12 md:col-3">
              <label htmlFor="DateEntered">{t('nova.datumKreiranja')}:</label>
                <Calendar
                  id="DateEntered"
                  name="DateEntered"
                  value={formData.DateEntered}
                  onChange={handleChange}
                  showIcon
                  mask="99.99.9999"
                  dateFormat="dd.mm.yy"
                  disabled
              />
            </div>
          </div>
         </AccordionTab>   
        {/* SPECIFIČNOSTI PODACI */}
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.specificnosti')}>
          {grupaFakture != 334  && <>
          <div className="gridFakture" style={{marginBottom:'1%'}}>
                        <div className="col-12 md:col-3">
              <label htmlFor="vozilo">{t('nova.vozilo')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <InputText
                id="vozilo"
                name="vozilo"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.vozilo) : null}
                value={formData.vozilo}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="cmr">CMR:</label>
              <InputText
                id="cmr"
                name="cmr"
                disabled={isLocked}
                value={formData.cmr}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="jci">JCI:</label>
              <InputText
                id="jci"
                name="jci"
                disabled={isLocked}
                value={formData.jci}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="gridFakture" style={{borderTop:'1px solid rgb(224, 221, 221)'}}>
            <div className="col-12 md:col-3">
              <label htmlFor="zemljaUtovara">{t('nova.zemljaUtovara')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <CustomDropdown
                id="zemljaUtovara"
                optionLabel="label"
                name="zemljaUtovara"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.zemljaUtovara) : null}
                value={formData.zemljaUtovara}
                options={drzaveOptions || []}
                onChange={handleChange}
                placeholder={t('nova.phDrzavu')}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="zemljaIstovara">{t('nova.zemljaIstovara')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
                <CustomDropdown
                id="zemljaIstovara"
                optionLabel="label"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.zemljaIstovara) : null}
                name="zemljaIstovara"
                value={formData.zemljaIstovara}
                options={drzaveOptions || []}
                onChange={handleChange}
                placeholder={t('nova.phDrzavu')}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="posiljalac">{t('nova.posiljalac')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <InputText
                id="posiljalac"
                name="posiljalac"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.posiljalac) : null}
                value={formData.posiljalac}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="primalac">{t('nova.primalac')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <InputText
                id="primalac"
                name="primalac"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.primalac) : null}
                value={formData.primalac}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="brojTure">{t('nova.brojTure')}:</label>
              <InputText
                id="brojTure"
                name="brojTure"
                readOnly
                style={{ backgroundColor: "#efefef" }}
                value={formData.brojTure}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="mestoIzvrsenjaUsluge">{t('ulazne.mestoIzvrsenja')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <InputText
                id="mestoIzvrsenjaUsluge"
                name="mestoIzvrsenjaUsluge"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.mestoIzvrsenjaUsluge) : null}
                value={formData.mestoIzvrsenjaUsluge}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="relacija">{t('nova.relacija')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <InputText
                id="relacija"
                name="relacija"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.relacija) : null}
                onChange={handleChange}
                value={formData.relacija}
              />
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="roba">{t('nova.roba')}:</label>
              <InputText
                id="roba"
                name="roba"
                disabled={isLocked}
                value={formData.roba}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="datumUtovara">{t('nova.datumUtovara')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <Calendar
                id="datumUtovara"
                name="datumUtovara"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.datumUtovara) : null}
                value={formData.datumUtovara}
                onChange={handleChange}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="datumIstovara">{t('nova.datumIstovara')}: {grupaFakture == 297 && <span className="iz-obavezno">*</span>}</label>
              <Calendar
                id="datumIstovara"
                name="datumIstovara"
                required={grupaFakture == 297}
                disabled={isLocked}
                invalid={grupaFakture == 297 ? invalidControl(formData.datumIstovara) : null}
                value={formData.datumIstovara}
                onChange={handleChange}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
          </div> </>}
        </AccordionTab>    
        {/* VALUTA / KURS */}
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.podaciValute')}>
          <div className="gridFakture">
            <div className="col-12 md:col-4">
              <label htmlFor="valuta">{t('nova.valuta')}:</label>
              <CustomDropdown
                id="valuta"
                name="valuta"
                disabled
                value={formData.valuta}
                options={valutaOptions}
                placeholder={t('nova.phValutu')}
                onChange={handleChange}
                optionLabel="label"
              />
            </div>

            <div className="col-12 md:col-4">
              <label htmlFor="kurs">{t('nova.kurs')}: <span className="iz-obavezno">*</span></label>
              <InputNumber
                id="kurs"
                name="kurs"
                required
                disabled={isLocked}
                invalid={invalidControl(formData.kurs)}
                value={formData.kurs}
                onValueChange={handleChange}
                minFractionDigits={4}
                maxFractionDigits={4}
              />
            </div>
            <div className="col-12 md:col-3">
              <label htmlFor="datumSlanjaPoste">{t('nova.datumSlanjaPoste')}:</label>
              <Calendar
                id="datumSlanjaPoste"
                name="datumSlanjaPoste"
                value={formData.datumSlanjaPoste}
                onChange={handleChange}
                disabled={isLocked}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>

            <div className="col-12 md:col-3">
              <label htmlFor="datumPrijemaPoste">{t('nova.datumPrijemaPoste')}:</label>
              <Calendar
                id="datumPrijemaPoste"
                name="datumPrijemaPoste"
                value={formData.datumPrijemaPoste}
                onChange={handleChange}
                disabled={isLocked}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
          </div>
        </AccordionTab>    
        {/* NAPOMENE */}
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.napomene')}>
          <div className="gridFakture">
            <div className="col-12" style={{flex: '0 0 39%', maxWidth:'50%'}}>
              <label htmlFor="napomenaPoreskoOslobadjanje">
                Napomena o poreskom oslobađanju:
              </label>
              <InputTextarea
                id="napomenaPoreskoOslobadjanje"
                name="napomenaPoreskoOslobadjanje"
                value={formData.napomenaPoreskoOslobadjanje}
                onChange={handleChange}
                disabled={isLocked}
                rows={3}
              />
            </div>

            <div className="col-12">
              <label htmlFor="napomena">{t('nova.napomena')}:</label>
              <InputTextarea
                id="napomena"
                name="napomena"
                value={formData.napomena}
                onChange={handleChange}
                disabled={isLocked}
                rows={3}
              />
            </div>
          </div>
        </AccordionTab>
        {/* STATUSI */}
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.statusi')}>
          <div className="gridFakture">
                      <div className="col-12 md:col-6">
                        <label htmlFor="statusSefa">{t('nova.statusSefa')}:</label>
                        <Dropdown
                          id="statusSefa"
                          name="statusSefa"
                          disabled={isLocked}
                          value={formData.statusSefa}
                          options={statusSefaOptions}
                          onChange={handleChange}
                          placeholder={t('nova.phStatus')}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label htmlFor="finansijskiStatus">{t('nova.finansijskiStatus')}:</label>
                        <Dropdown
                          id="finansijskiStatus"
                          name="finansijskiStatus"
                          disabled={isHardLocked}
                          value={formData.finansijskiStatus}
                          options={finansijskiStatusOptions}
                          onChange={handleChange}
                          placeholder={t('nova.phStatus')}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label>{t('nova.sefStatusSa')}:</label>
                        <InputText
                          readOnly
                          value={formData.sefStatusString || ''}
                          placeholder="—"
                          style={{ width: '100%', background: '#f5f5f5' }}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label>{t('nova.sefKomentar')}:</label>
                        <InputText
                          readOnly
                          value={formData.sefKomentar || ''}
                          placeholder="—"
                          style={{ width: '100%', background: '#f5f5f5' }}
                        />
                      </div>
          </div>
        </AccordionTab>

        {(props.idPredracunZaKonacni || idPredracunVezan) ? (
        <AccordionTab id="AccordionTabUnosZaposlenih" header={t('nova.avansniRacuni')}>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.8rem', alignItems: 'center' }}>
            <div style={{ flex: '0 0 calc(50% - 0.5rem)' }}>
              <p className="infoPoruka" style={{ margin: 0 }}>
                Konačna faktura za predračun: <strong>{brojPredracunaPrikaz}</strong>
              </p>
            </div>
            <div style={{ flex: '0 0 calc(50% - 0.5rem)' }}>
              {avansniZaPrikaz.length > 0 && (() => {
                const kursNum = parseFloat(formData.kurs) || 1;
                const stavkaVal = (selectedPredracunStavke[0] || predracunStavkeZaIzbor[0])?.iznosValuta;
                const valLbl = (selectedPredracunStavke[0] || predracunStavkeZaIzbor[0])?.iznosValutaNaziv || '';
                const sumSel = selectedPredracunStavke.reduce((s, r) => s + parseFloat(r.iznos || 0), 0);
                const sumAv = avansniZaPrikaz.reduce((s, a) => {
                  const ai = parseFloat(a.Iznos || 0);
                  if (a.IznosValuta === stavkaVal) return s + ai;
                  if (a.IznosValuta === 220 && stavkaVal !== 220) return s + (kursNum > 1 ? ai / kursNum : ai);
                  if (a.IznosValuta !== 220 && stavkaVal === 220) return s + ai * kursNum;
                  return s + ai;
                }, 0);
                const ok = sumAv - sumSel <= 0.01;
                return (
                  <div style={{ padding: '6px 10px', borderRadius: '4px', fontWeight: 600, fontSize: '12px',
                    background: ok ? '#e8f5e9' : '#ffebee', border: `1px solid ${ok ? '#a5d6a7' : '#ef9a9a'}`,
                    color: ok ? '#2e7d32' : '#c62828' }}>
                    {ok ? `✓ Pokriveno ${Math.min(sumSel,sumAv).toFixed(2)} ${valLbl} od ${sumAv.toFixed(2)} ${valLbl} avansnih uplata`
                        : `✗ Nedostaje ${(sumAv-sumSel).toFixed(2)} ${valLbl} — izaberi još stavki`}
                  </div>
                );
              })()}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <div style={{ flex: '0 0 calc(50% - 0.5rem)', minWidth: '280px' }}>
              <h5 style={{ margin: '0 0 0.5rem' }}>Avansne uplate po ovom predračunu</h5>
              <DataTable value={avansniZaPrikaz} emptyMessage="Nema avansnih uplata po ovom predračunu" scrollable scrollHeight="200px">
                <Column field="BrojRacuna" header={t('nova.brojAvansnog')} style={{ minWidth: '110px' }} />
                <Column field="Iznos" header={t('nova.iznos')} style={{ minWidth: '120px' }}
                  body={r => `${parseFloat(r.Iznos).toFixed(2)} ${r.Valuta || ''}`} />
                <Column field="datumUplate" header={t('nova.datumUplate')} style={{ minWidth: '100px' }}
                  body={r => r.datumUplate ? new Date(r.datumUplate).toLocaleDateString('sr-RS') : '-'} />
                <Column header={t('nova.sefStatus')} style={{ minWidth: '100px' }}
                  body={r => r.sefSalesInvId ? <span style={{ color: '#2e7d32', fontWeight: 600 }}>{r.sefStatus || 'Poslato'}</span> : <span style={{ color: '#999' }}>—</span>} />
              </DataTable>
            </div>
            <div style={{ flex: '0 0 calc(50% - 0.5rem)', minWidth: '280px' }}>
              <h5 style={{ margin: '0 0 0.5rem' }}>Stavke predračuna — izaberi koje idu u ovu fakturu</h5>
              <DataTable value={predracunStavkeZaIzbor} dataKey="id_predracun_stavka"
                selection={selectedPredracunStavke}
                onSelectionChange={e => {
                  const sel = e.value || [];
                  setSelectedPredracunStavke(sel);
                  const kursNum = parseFloat(formData.kurs) || 1;
                  const stavkaVal = (sel[0] || predracunStavkeZaIzbor[0])?.iznosValuta;
                  const sumSel = sel.reduce((s, r) => s + parseFloat(r.iznos || 0), 0);
                  const sumAv = avansniZaPrikaz.reduce((s, a) => {
                    const ai = parseFloat(a.Iznos || 0);
                    if (a.IznosValuta === stavkaVal) return s + ai;
                    if (a.IznosValuta === 220 && stavkaVal !== 220) return s + (kursNum > 1 ? ai / kursNum : ai);
                    if (a.IznosValuta !== 220 && stavkaVal === 220) return s + ai * kursNum;
                    return s + ai;
                  }, 0);
                  const first = sel[0];
                  setFormData(prev => ({
                    ...prev, iznos: parseFloat(sumSel.toFixed(2)),
                    ...(first ? { vozilo: first.vozilo||'', cmr: first.cmr||'', iznosValuta: first.iznosValuta||prev.iznosValuta,
                      zemljaUtovara: first.zemljaUtovara||null, zemljaIstovara: first.zemljaIstovara||null,
                      posiljalac: first.posiljalac||'', primalac: first.primalac||'',
                      brojTure: first.brojTure||'', relacija: first.relacija||'', roba: first.roba||'',
                      datumUtovara: first.datumUtovara ? new Date(first.datumUtovara) : null,
                      datumIstovara: first.datumIstovara ? new Date(first.datumIstovara) : null } : {}),
                  }));
                  if (first) setIdTrip(first.id_from_group || null);
                }}
                emptyMessage="Nema nefakturisanih stavki" scrollable scrollHeight="200px">
                <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                <Column field="brojTure" header={t('nova.tura')} style={{ minWidth: '100px' }} />
                <Column header={t('nova.opis')} style={{ minWidth: '160px' }}
                  body={r => r.tekst || r.slobodanTekst || r.relacija || '-'} />
                <Column header={t('nova.iznos')} style={{ minWidth: '110px' }}
                  body={r => `${parseFloat(r.iznos || 0).toFixed(2)} ${r.iznosValutaNaziv || ''}`} />
              </DataTable>
            </div>
          </div>
        </AccordionTab>
        ) : null}

        </Accordion>

      </form>
        <div className="zaposleni_table_container tableItems" style={{maxHeight: '60vh',marginBottom:'0 !important', ...(isHardLocked ? { opacity: 0.6 } : {})}}>
          <Toast ref={toast} />
              <Tooltip target=".export-buttons>button" position="bottom" />
              <DataTable
                paginator
                rows={3}
                first={first}
                globalFilter={globalFilter}
                onPage={(e) => setFirst(e.first)}
                scrollable
                header={header}
                scrollHeight="15vh"
                emptyMessage={t('common.noDataTable')}
                value={tableData || []}
                resizableColumns
                className="izlazneFaktureTable stavke-tabela"
                columnResizeMode="expand"
                rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
              >
                {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={colMeta?.label || colKey}
                    sortable
                    body={(rowData) => {
                      if (isButtonColumn(colKey)) {
                        return previewBodyTemplate(rowData, colKey);
                      }
                      return rowData[colKey] ?? '-';
                    }}
                  />
                );
              })}
              </DataTable>
            </div>
      <div className="formUnosZap buttonUnosZap buttonUnosFakture">
        <button
          type="submit"
          onClick={handleFormSubmit}
          className="btn btn-success"
          disabled={isHardLocked}
        >
          {props.idInvoice || idInvoice || izabran ? t('common.save') : t('admin.unos')}
        </button>

      </div>
    </div>
  );
};

export default NovaDinarska;
